"use client";
// src/_check-rsc.ts
import { createContext } from "react";
if (typeof createContext !== "function") {
  const err = [
    'Remotion requires React.createContext, but it is "undefined".',
    'If you are in a React Server Component, turn it into a client component by adding "use client" at the top of the file.',
    "",
    "Before:",
    '  import {Player} from "@remotion/player";',
    "",
    "After:",
    '  "use client";',
    '  import {Player} from "@remotion/player";'
  ];
  throw new Error(err.join(`
`));
}

// src/icons.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var ICON_SIZE = 25;
var fullscreenIconSize = 16;
var PlayIcon = () => {
  return /* @__PURE__ */ jsx("svg", {
    width: ICON_SIZE,
    height: ICON_SIZE,
    viewBox: "0 0 25 25",
    fill: "none",
    children: /* @__PURE__ */ jsx("path", {
      d: "M8 6.375C7.40904 8.17576 7.06921 10.2486 7.01438 12.3871C6.95955 14.5255 7.19163 16.6547 7.6875 18.5625C9.95364 18.2995 12.116 17.6164 14.009 16.5655C15.902 15.5147 17.4755 14.124 18.6088 12.5C17.5158 10.8949 15.9949 9.51103 14.1585 8.45082C12.3222 7.3906 10.2174 6.68116 8 6.375Z",
      fill: "white",
      stroke: "white",
      strokeWidth: "6.25",
      strokeLinejoin: "round"
    })
  });
};
var PauseIcon = () => {
  return /* @__PURE__ */ jsxs("svg", {
    viewBox: "0 0 100 100",
    width: ICON_SIZE,
    height: ICON_SIZE,
    children: [
      /* @__PURE__ */ jsx("rect", {
        x: "25",
        y: "20",
        width: "20",
        height: "60",
        fill: "#fff",
        ry: "5",
        rx: "5"
      }),
      /* @__PURE__ */ jsx("rect", {
        x: "55",
        y: "20",
        width: "20",
        height: "60",
        fill: "#fff",
        ry: "5",
        rx: "5"
      })
    ]
  });
};
var FullscreenIcon = ({
  isFullscreen
}) => {
  const strokeWidth = 6;
  const viewSize = 32;
  const out = isFullscreen ? 0 : strokeWidth / 2;
  const middleInset = isFullscreen ? strokeWidth * 1.6 : strokeWidth / 2;
  const inset = isFullscreen ? strokeWidth * 1.6 : strokeWidth * 2;
  return /* @__PURE__ */ jsxs("svg", {
    viewBox: `0 0 ${viewSize} ${viewSize}`,
    height: fullscreenIconSize,
    width: fullscreenIconSize,
    children: [
      /* @__PURE__ */ jsx("path", {
        d: `
				M ${out} ${inset}
				L ${middleInset} ${middleInset}
				L ${inset} ${out}
				`,
        stroke: "#fff",
        strokeWidth,
        fill: "none"
      }),
      /* @__PURE__ */ jsx("path", {
        d: `
				M ${viewSize - out} ${inset}
				L ${viewSize - middleInset} ${middleInset}
				L ${viewSize - inset} ${out}
				`,
        stroke: "#fff",
        strokeWidth,
        fill: "none"
      }),
      /* @__PURE__ */ jsx("path", {
        d: `
				M ${out} ${viewSize - inset}
				L ${middleInset} ${viewSize - middleInset}
				L ${inset} ${viewSize - out}
				`,
        stroke: "#fff",
        strokeWidth,
        fill: "none"
      }),
      /* @__PURE__ */ jsx("path", {
        d: `
				M ${viewSize - out} ${viewSize - inset}
				L ${viewSize - middleInset} ${viewSize - middleInset}
				L ${viewSize - inset} ${viewSize - out}
				`,
        stroke: "#fff",
        strokeWidth,
        fill: "none"
      })
    ]
  });
};
var VolumeOffIcon = () => {
  return /* @__PURE__ */ jsx("svg", {
    width: ICON_SIZE,
    height: ICON_SIZE,
    viewBox: "0 0 24 24",
    children: /* @__PURE__ */ jsx("path", {
      d: "M3.63 3.63a.996.996 0 000 1.41L7.29 8.7 7 9H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71v-4.17l4.18 4.18c-.49.37-1.02.68-1.6.91-.36.15-.58.53-.58.92 0 .72.73 1.18 1.39.91.8-.33 1.55-.77 2.22-1.31l1.34 1.34a.996.996 0 101.41-1.41L5.05 3.63c-.39-.39-1.02-.39-1.42 0zM19 12c0 .82-.15 1.61-.41 2.34l1.53 1.53c.56-1.17.88-2.48.88-3.87 0-3.83-2.4-7.11-5.78-8.4-.59-.23-1.22.23-1.22.86v.19c0 .38.25.71.61.85C17.18 6.54 19 9.06 19 12zm-8.71-6.29l-.17.17L12 7.76V6.41c0-.89-1.08-1.33-1.71-.7zM16.5 12A4.5 4.5 0 0014 7.97v1.79l2.48 2.48c.01-.08.02-.16.02-.24z",
      fill: "#fff"
    })
  });
};
var VolumeOnIcon = () => {
  return /* @__PURE__ */ jsx("svg", {
    width: ICON_SIZE,
    height: ICON_SIZE,
    viewBox: "0 0 24 24",
    children: /* @__PURE__ */ jsx("path", {
      d: "M3 10v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71V6.41c0-.89-1.08-1.34-1.71-.71L7 9H4c-.55 0-1 .45-1 1zm13.5 2A4.5 4.5 0 0014 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 4.45v.2c0 .38.25.71.6.85C17.18 6.53 19 9.06 19 12s-1.82 5.47-4.4 6.5c-.36.14-.6.47-.6.85v.2c0 .63.63 1.07 1.21.85C18.6 19.11 21 15.84 21 12s-2.4-7.11-5.79-8.4c-.58-.23-1.21.22-1.21.85z",
      fill: "#fff"
    })
  });
};

// src/BufferingIndicator.tsx
import { jsx as jsx2, jsxs as jsxs2, Fragment } from "react/jsx-runtime";
var className = "__remotion_buffering_indicator";
var remotionBufferingAnimation = "__remotion_buffering_animation";
var playerStyle = {
  width: ICON_SIZE,
  height: ICON_SIZE,
  overflow: "hidden",
  lineHeight: "normal",
  fontSize: "inherit"
};
var studioStyle = {
  width: 14,
  height: 14,
  overflow: "hidden",
  lineHeight: "normal",
  fontSize: "inherit"
};
var BufferingIndicator = ({ type, color = "white" }) => {
  const style = type === "player" ? playerStyle : studioStyle;
  return /* @__PURE__ */ jsxs2(Fragment, {
    children: [
      /* @__PURE__ */ jsx2("style", {
        type: "text/css",
        children: `
				@keyframes ${remotionBufferingAnimation} {
          0% {
            rotate: 0deg;
          }
          100% {
            rotate: 360deg;
          }
        }
        
        .${className} {
            animation: ${remotionBufferingAnimation} 1s linear infinite;
        }        
			`
      }),
      /* @__PURE__ */ jsx2("div", {
        style,
        children: /* @__PURE__ */ jsx2("svg", {
          viewBox: type === "player" ? "0 0 22 22" : "0 0 18 18",
          style,
          className,
          children: /* @__PURE__ */ jsx2("path", {
            d: type === "player" ? "M 11 4 A 7 7 0 0 1 15.1145 16.66312" : "M 9 2 A 7 7 0 0 1 13.1145 14.66312",
            stroke: color,
            strokeLinecap: "round",
            fill: "none",
            strokeWidth: 3
          })
        })
      })
    ]
  });
};

// src/calculate-scale.ts
import { Internals } from "remotion";

// src/utils/calculate-player-size.ts
var calculatePlayerSize = ({
  currentSize,
  width,
  height,
  compositionWidth,
  compositionHeight
}) => {
  if (width !== undefined && height === undefined) {
    return {
      aspectRatio: [compositionWidth, compositionHeight].join("/")
    };
  }
  if (height !== undefined && width === undefined) {
    return {
      aspectRatio: [compositionWidth, compositionHeight].join("/")
    };
  }
  if (!currentSize) {
    return {
      width: compositionWidth,
      height: compositionHeight
    };
  }
  return {
    width: compositionWidth,
    height: compositionHeight
  };
};

// src/calculate-scale.ts
var calculateCanvasTransformation = ({
  previewSize,
  compositionWidth,
  compositionHeight,
  canvasSize
}) => {
  const scale = Internals.calculateScale({
    canvasSize,
    compositionHeight,
    compositionWidth,
    previewSize
  });
  const correction = 0 - (1 - scale) / 2;
  const xCorrection = correction * compositionWidth;
  const yCorrection = correction * compositionHeight;
  const width = compositionWidth * scale;
  const height = compositionHeight * scale;
  const centerX = canvasSize.width / 2 - width / 2;
  const centerY = canvasSize.height / 2 - height / 2;
  return {
    centerX,
    centerY,
    xCorrection,
    yCorrection,
    scale
  };
};
var calculateOuterStyle = ({
  config,
  style,
  canvasSize,
  overflowVisible,
  layout
}) => {
  if (!config) {
    return {};
  }
  return {
    position: "relative",
    overflow: overflowVisible ? "visible" : "hidden",
    ...calculatePlayerSize({
      compositionHeight: config.height,
      compositionWidth: config.width,
      currentSize: canvasSize,
      height: style?.height,
      width: style?.width
    }),
    opacity: layout ? 1 : 0,
    ...style
  };
};
var calculateContainerStyle = ({
  config,
  layout,
  scale,
  overflowVisible
}) => {
  if (!config) {
    return {};
  }
  if (!layout) {
    return {
      position: "absolute",
      width: config.width,
      height: config.height,
      display: "flex",
      transform: `scale(${scale})`,
      overflow: overflowVisible ? "visible" : "hidden"
    };
  }
  return {
    position: "absolute",
    width: config.width,
    height: config.height,
    display: "flex",
    transform: `scale(${scale})`,
    marginLeft: layout.xCorrection,
    marginTop: layout.yCorrection,
    overflow: overflowVisible ? "visible" : "hidden"
  };
};
var calculateOuter = ({
  layout,
  scale,
  config,
  overflowVisible
}) => {
  if (!config) {
    return {};
  }
  if (!layout) {
    return {
      width: config.width * scale,
      height: config.height * scale,
      display: "flex",
      flexDirection: "column",
      position: "absolute",
      overflow: overflowVisible ? "visible" : "hidden"
    };
  }
  const { centerX, centerY } = layout;
  return {
    width: config.width * scale,
    height: config.height * scale,
    display: "flex",
    flexDirection: "column",
    position: "absolute",
    left: centerX,
    top: centerY,
    overflow: overflowVisible ? "visible" : "hidden"
  };
};

// src/canvas-overlay-context.ts
import { createContext as createContext2 } from "react";
var CanvasOverlayContext = createContext2(null);
var CanvasContentContext = createContext2(null);

// src/emitter-context.ts
import React from "react";
var PlayerEventEmitterContext = React.createContext(undefined);
var ThumbnailEmitterContext = React.createContext(undefined);

// src/EmitterProvider.tsx
import { useEffect, useState } from "react";

// src/event-emitter.ts
class PlayerEmitter {
  listeners = {
    ended: [],
    error: [],
    pause: [],
    play: [],
    ratechange: [],
    scalechange: [],
    seeked: [],
    timeupdate: [],
    frameupdate: [],
    fullscreenchange: [],
    volumechange: [],
    mutechange: [],
    waiting: [],
    resume: []
  };
  addEventListener(name, callback) {
    this.listeners[name].push(callback);
  }
  removeEventListener(name, callback) {
    this.listeners[name] = this.listeners[name].filter((l) => l !== callback);
  }
  dispatchEvent(dispatchName, context) {
    this.listeners[dispatchName].forEach((callback) => {
      callback({ detail: context });
    });
  }
  dispatchSeek = (frame) => {
    this.dispatchEvent("seeked", {
      frame
    });
  };
  dispatchVolumeChange = (volume) => {
    this.dispatchEvent("volumechange", {
      volume
    });
  };
  dispatchPause = () => {
    this.dispatchEvent("pause", undefined);
  };
  dispatchPlay = () => {
    this.dispatchEvent("play", undefined);
  };
  dispatchEnded = () => {
    this.dispatchEvent("ended", undefined);
  };
  dispatchRateChange = (playbackRate) => {
    this.dispatchEvent("ratechange", {
      playbackRate
    });
  };
  dispatchScaleChange = (scale) => {
    this.dispatchEvent("scalechange", {
      scale
    });
  };
  dispatchError = (error) => {
    this.dispatchEvent("error", {
      error
    });
  };
  dispatchTimeUpdate = (event) => {
    this.dispatchEvent("timeupdate", event);
  };
  dispatchFrameUpdate = (event) => {
    this.dispatchEvent("frameupdate", event);
  };
  dispatchFullscreenChange = (event) => {
    this.dispatchEvent("fullscreenchange", event);
  };
  dispatchMuteChange = (event) => {
    this.dispatchEvent("mutechange", event);
  };
  dispatchWaiting = (event) => {
    this.dispatchEvent("waiting", event);
  };
  dispatchResume = (event) => {
    this.dispatchEvent("resume", event);
  };
}

class ThumbnailEmitter {
  listeners = {
    error: [],
    waiting: [],
    resume: []
  };
  addEventListener(name, callback) {
    this.listeners[name].push(callback);
  }
  removeEventListener(name, callback) {
    this.listeners[name] = this.listeners[name].filter((l) => l !== callback);
  }
  dispatchEvent(dispatchName, context) {
    this.listeners[dispatchName].forEach((callback) => {
      callback({ detail: context });
    });
  }
  dispatchError = (error) => {
    this.dispatchEvent("error", {
      error
    });
  };
  dispatchWaiting = (event) => {
    this.dispatchEvent("waiting", event);
  };
  dispatchResume = (event) => {
    this.dispatchEvent("resume", event);
  };
}

// src/use-buffer-state-emitter.ts
import { useContext, useLayoutEffect } from "react";
import { Internals as Internals2 } from "remotion";
var useBufferStateEmitter = (emitter) => {
  const { subscribeBuffering } = useContext(Internals2.SetTimelineContext);
  useLayoutEffect(() => {
    return subscribeBuffering((state) => {
      if (state.buffering) {
        emitter.dispatchWaiting({});
      } else {
        emitter.dispatchResume({});
      }
    });
  }, [emitter, subscribeBuffering]);
};

// src/EmitterProvider.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var PlayerEmitterProvider = ({ children, currentPlaybackRate }) => {
  const [emitter] = useState(() => new PlayerEmitter);
  useEffect(() => {
    if (currentPlaybackRate) {
      emitter.dispatchRateChange(currentPlaybackRate);
    }
  }, [emitter, currentPlaybackRate]);
  useBufferStateEmitter(emitter);
  return /* @__PURE__ */ jsx3(PlayerEventEmitterContext.Provider, {
    value: emitter,
    children
  });
};

// src/PlayerControls.tsx
import { useCallback as useCallback7, useEffect as useEffect7, useMemo as useMemo9, useRef as useRef5, useState as useState9 } from "react";

// src/DefaultPlayPauseButton.tsx
import { jsx as jsx4 } from "react/jsx-runtime";
var DefaultPlayPauseButton = ({ playing, buffering }) => {
  if (playing && buffering) {
    return /* @__PURE__ */ jsx4(BufferingIndicator, {
      type: "player"
    });
  }
  if (playing) {
    return /* @__PURE__ */ jsx4(PauseIcon, {});
  }
  return /* @__PURE__ */ jsx4(PlayIcon, {});
};

// src/MediaVolumeSlider.tsx
import { useCallback as useCallback2, useMemo as useMemo2, useRef, useState as useState4 } from "react";
import { Internals as Internals3 } from "remotion";

// src/render-volume-slider.tsx
import React3, { useCallback, useMemo, useState as useState2 } from "react";
import { random } from "remotion";
import { jsx as jsx5, jsxs as jsxs3 } from "react/jsx-runtime";
var KNOB_SIZE = 12;
var BAR_HEIGHT = 5;
var DefaultVolumeSlider = ({
  volume,
  isVertical,
  onBlur,
  inputRef,
  setVolume
}) => {
  const sliderContainer = useMemo(() => {
    const paddingLeft = 5;
    const common = {
      paddingLeft,
      height: ICON_SIZE,
      width: VOLUME_SLIDER_WIDTH,
      display: "inline-flex",
      alignItems: "center"
    };
    if (isVertical) {
      return {
        ...common,
        position: "absolute",
        transform: `rotate(-90deg) translateX(${VOLUME_SLIDER_WIDTH / 2 + ICON_SIZE / 2}px)`
      };
    }
    return {
      ...common
    };
  }, [isVertical]);
  const randomId = typeof React3.useId === "undefined" ? "volume-slider" : React3.useId();
  const [randomClass] = useState2(() => `__remotion-volume-slider-${random(randomId)}`.replace(".", ""));
  const onVolumeChange = useCallback((e) => {
    setVolume(parseFloat(e.target.value));
  }, [setVolume]);
  const inputStyle = useMemo(() => {
    const commonStyle = {
      WebkitAppearance: "none",
      backgroundColor: "rgba(255, 255, 255, 0.5)",
      borderRadius: BAR_HEIGHT / 2,
      cursor: "pointer",
      height: BAR_HEIGHT,
      width: VOLUME_SLIDER_WIDTH,
      backgroundImage: `linear-gradient(
				to right,
				white ${volume * 100}%, rgba(255, 255, 255, 0) ${volume * 100}%
			)`
    };
    if (isVertical) {
      return {
        ...commonStyle,
        bottom: ICON_SIZE + VOLUME_SLIDER_WIDTH / 2
      };
    }
    return commonStyle;
  }, [isVertical, volume]);
  const sliderStyle = `
	.${randomClass}::-webkit-slider-thumb {
		-webkit-appearance: none;
		background-color: white;
		border-radius: ${KNOB_SIZE / 2}px;
		box-shadow: 0 0 2px black;
		height: ${KNOB_SIZE}px;
		width: ${KNOB_SIZE}px;
	}

	.${randomClass}::-moz-range-thumb {
		-webkit-appearance: none;
		background-color: white;
		border-radius: ${KNOB_SIZE / 2}px;
		box-shadow: 0 0 2px black;
		height: ${KNOB_SIZE}px;
		width: ${KNOB_SIZE}px;
	}
`;
  return /* @__PURE__ */ jsxs3("div", {
    style: sliderContainer,
    children: [
      /* @__PURE__ */ jsx5("style", {
        dangerouslySetInnerHTML: {
          __html: sliderStyle
        }
      }),
      /* @__PURE__ */ jsx5("input", {
        ref: inputRef,
        "aria-label": "Change volume",
        className: randomClass,
        max: 1,
        min: 0,
        onBlur,
        onChange: onVolumeChange,
        step: 0.01,
        type: "range",
        value: volume,
        style: inputStyle
      })
    ]
  });
};
var renderDefaultVolumeSlider = (props) => {
  return /* @__PURE__ */ jsx5(DefaultVolumeSlider, {
    ...props
  });
};

// src/use-hover-state.ts
import { useEffect as useEffect2, useState as useState3 } from "react";
var useHoverState = (ref, hideControlsWhenPointerDoesntMove) => {
  const [hovered, setHovered] = useState3(false);
  useEffect2(() => {
    const { current } = ref;
    if (!current) {
      return;
    }
    let hoverTimeout;
    const addHoverTimeout = () => {
      if (hideControlsWhenPointerDoesntMove) {
        clearTimeout(hoverTimeout);
        hoverTimeout = setTimeout(() => {
          setHovered(false);
        }, hideControlsWhenPointerDoesntMove === true ? 3000 : hideControlsWhenPointerDoesntMove);
      }
    };
    const onHover = () => {
      setHovered(true);
      addHoverTimeout();
    };
    const onLeave = () => {
      setHovered(false);
      clearTimeout(hoverTimeout);
    };
    const onMove = () => {
      setHovered(true);
      addHoverTimeout();
    };
    current.addEventListener("mouseenter", onHover);
    current.addEventListener("mouseleave", onLeave);
    current.addEventListener("mousemove", onMove);
    return () => {
      current.removeEventListener("mouseenter", onHover);
      current.removeEventListener("mouseleave", onLeave);
      current.removeEventListener("mousemove", onMove);
      clearTimeout(hoverTimeout);
    };
  }, [hideControlsWhenPointerDoesntMove, ref]);
  return hovered;
};

// src/MediaVolumeSlider.tsx
import { jsx as jsx6, jsxs as jsxs4 } from "react/jsx-runtime";
var VOLUME_SLIDER_WIDTH = 100;
var MediaVolumeSlider = ({ displayVerticalVolumeSlider, renderMuteButton, renderVolumeSlider }) => {
  const [playerMuted, setPlayerMuted] = Internals3.usePlayerMutedState();
  const [mediaVolume, setMediaVolume] = Internals3.useMediaVolumeState();
  const [focused, setFocused] = useState4(false);
  const parentDivRef = useRef(null);
  const inputRef = useRef(null);
  const hover = useHoverState(parentDivRef, false);
  const onBlur = useCallback2(() => {
    setTimeout(() => {
      if (inputRef.current && document.activeElement !== inputRef.current) {
        setFocused(false);
      }
    }, 10);
  }, []);
  const isVolume0 = mediaVolume === 0;
  const onClick = useCallback2(() => {
    if (isVolume0) {
      setMediaVolume(1);
      setPlayerMuted(false);
      return;
    }
    setPlayerMuted((mute) => !mute);
  }, [isVolume0, setPlayerMuted, setMediaVolume]);
  const parentDivStyle = useMemo2(() => {
    return {
      display: "inline-flex",
      background: "none",
      border: "none",
      justifyContent: "center",
      alignItems: "center",
      touchAction: "none",
      ...displayVerticalVolumeSlider && { position: "relative" }
    };
  }, [displayVerticalVolumeSlider]);
  const volumeContainer = useMemo2(() => {
    return {
      display: "inline",
      width: ICON_SIZE,
      height: ICON_SIZE,
      cursor: "pointer",
      appearance: "none",
      background: "none",
      border: "none",
      padding: 0
    };
  }, []);
  const renderDefaultMuteButton = useCallback2(({ muted, volume }) => {
    const isMutedOrZero = muted || volume === 0;
    return /* @__PURE__ */ jsx6("button", {
      "aria-label": isMutedOrZero ? "Unmute sound" : "Mute sound",
      title: isMutedOrZero ? "Unmute sound" : "Mute sound",
      onClick,
      onBlur,
      onFocus: () => setFocused(true),
      style: volumeContainer,
      type: "button",
      children: isMutedOrZero ? /* @__PURE__ */ jsx6(VolumeOffIcon, {}) : /* @__PURE__ */ jsx6(VolumeOnIcon, {})
    });
  }, [onBlur, onClick, volumeContainer]);
  const muteButton = useMemo2(() => {
    return renderMuteButton ? renderMuteButton({ muted: playerMuted, volume: mediaVolume }) : renderDefaultMuteButton({ muted: playerMuted, volume: mediaVolume });
  }, [playerMuted, mediaVolume, renderDefaultMuteButton, renderMuteButton]);
  const volumeSlider = useMemo2(() => {
    return (focused || hover) && !playerMuted && !Internals3.isIosSafari() ? (renderVolumeSlider ?? renderDefaultVolumeSlider)({
      isVertical: displayVerticalVolumeSlider,
      volume: mediaVolume,
      onBlur: () => setFocused(false),
      inputRef,
      setVolume: setMediaVolume
    }) : null;
  }, [
    displayVerticalVolumeSlider,
    focused,
    hover,
    playerMuted,
    mediaVolume,
    renderVolumeSlider,
    setMediaVolume
  ]);
  return /* @__PURE__ */ jsxs4("div", {
    ref: parentDivRef,
    style: parentDivStyle,
    children: [
      muteButton,
      volumeSlider
    ]
  });
};

// src/PlaybackrateControl.tsx
import { useCallback as useCallback3, useEffect as useEffect4, useMemo as useMemo3, useState as useState6 } from "react";
import { Internals as Internals4 } from "remotion";

// src/utils/use-component-visible.ts
import { useEffect as useEffect3, useRef as useRef2, useState as useState5 } from "react";
function useComponentVisible(initialIsVisible) {
  const [isComponentVisible, setIsComponentVisible] = useState5(initialIsVisible);
  const ref = useRef2(null);
  useEffect3(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsComponentVisible(false);
      }
    };
    document.addEventListener("pointerup", handleClickOutside, true);
    return () => {
      document.removeEventListener("pointerup", handleClickOutside, true);
    };
  }, []);
  return { ref, isComponentVisible, setIsComponentVisible };
}

// src/PlaybackrateControl.tsx
import { jsx as jsx7, jsxs as jsxs5 } from "react/jsx-runtime";
var BOTTOM = 35;
var THRESHOLD = 70;
var rateDiv = {
  height: 30,
  paddingRight: 15,
  paddingLeft: 12,
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};
var checkmarkContainer = {
  width: 22,
  display: "flex",
  alignItems: "center"
};
var checkmarkStyle = {
  width: 14,
  height: 14,
  color: "black"
};
var Checkmark = () => /* @__PURE__ */ jsx7("svg", {
  viewBox: "0 0 512 512",
  style: checkmarkStyle,
  children: /* @__PURE__ */ jsx7("path", {
    fill: "currentColor",
    d: "M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z"
  })
});
var formatPlaybackRate = (rate) => {
  const str = rate.toString();
  return str.includes(".") ? str : str + ".0";
};
var PlaybackrateOption = ({ rate, onSelect, selectedRate, keyboardSelectedRate }) => {
  const onClick = useCallback3((e) => {
    e.stopPropagation();
    e.preventDefault();
    onSelect(rate);
  }, [onSelect, rate]);
  const [hovered, setHovered] = useState6(false);
  const onMouseEnter = useCallback3(() => {
    setHovered(true);
  }, []);
  const onMouseLeave = useCallback3(() => {
    setHovered(false);
  }, []);
  const isFocused = keyboardSelectedRate === rate;
  const actualStyle = useMemo3(() => {
    return {
      ...rateDiv,
      backgroundColor: hovered || isFocused ? "#eee" : "transparent"
    };
  }, [hovered, isFocused]);
  return /* @__PURE__ */ jsxs5("div", {
    onPointerEnter: onMouseEnter,
    onPointerLeave: onMouseLeave,
    tabIndex: 0,
    style: actualStyle,
    onClick,
    children: [
      /* @__PURE__ */ jsx7("div", {
        style: checkmarkContainer,
        children: rate === selectedRate ? /* @__PURE__ */ jsx7(Checkmark, {}) : null
      }),
      formatPlaybackRate(rate),
      "x"
    ]
  }, rate);
};
var PlaybackPopup = ({ setIsComponentVisible, playbackRates, canvasSize }) => {
  const { setPlaybackRate, playbackRate } = Internals4.usePlaybackRate();
  const [keyboardSelectedRate, setKeyboardSelectedRate] = useState6(playbackRate);
  useEffect4(() => {
    const listener = (e) => {
      if (e.ctrlKey || e.metaKey || e.altKey) {
        return;
      }
      if (e.key === "ArrowUp") {
        e.preventDefault();
        const currentIndex = playbackRates.findIndex((rate) => rate === keyboardSelectedRate);
        if (currentIndex === 0) {
          return;
        }
        if (currentIndex === -1) {
          setKeyboardSelectedRate(playbackRates[0]);
        } else {
          setKeyboardSelectedRate(playbackRates[currentIndex - 1]);
        }
      } else if (e.key === "ArrowDown") {
        e.preventDefault();
        const currentIndex = playbackRates.findIndex((rate) => rate === keyboardSelectedRate);
        if (currentIndex === playbackRates.length - 1) {
          return;
        }
        if (currentIndex === -1) {
          setKeyboardSelectedRate(playbackRates[playbackRates.length - 1]);
        } else {
          setKeyboardSelectedRate(playbackRates[currentIndex + 1]);
        }
      } else if (e.key === "Enter") {
        e.preventDefault();
        setPlaybackRate(keyboardSelectedRate);
        setIsComponentVisible(false);
      } else if (e.key === "Escape") {
        e.preventDefault();
        setIsComponentVisible(false);
      } else if (e.key === "Tab") {
        setIsComponentVisible(false);
      }
    };
    window.addEventListener("keydown", listener);
    return () => {
      window.removeEventListener("keydown", listener);
    };
  }, [
    playbackRates,
    keyboardSelectedRate,
    setPlaybackRate,
    setIsComponentVisible
  ]);
  const onSelect = useCallback3((rate) => {
    setPlaybackRate(rate);
    setIsComponentVisible(false);
  }, [setIsComponentVisible, setPlaybackRate]);
  const playbackPopup = useMemo3(() => {
    return {
      position: "absolute",
      right: 0,
      width: 125,
      maxHeight: canvasSize.height - THRESHOLD - BOTTOM,
      bottom: 35,
      background: "#fff",
      borderRadius: 4,
      overflow: "auto",
      color: "black",
      textAlign: "left"
    };
  }, [canvasSize.height]);
  return /* @__PURE__ */ jsx7("div", {
    style: playbackPopup,
    children: playbackRates.map((rate) => {
      return /* @__PURE__ */ jsx7(PlaybackrateOption, {
        selectedRate: playbackRate,
        onSelect,
        rate,
        keyboardSelectedRate
      }, rate);
    })
  });
};
var label = {
  fontSize: 13,
  fontWeight: "bold",
  color: "white",
  border: "2px solid white",
  borderRadius: 20,
  paddingLeft: 8,
  paddingRight: 8,
  paddingTop: 2,
  paddingBottom: 2
};
var playerButtonStyle = {
  appearance: "none",
  backgroundColor: "transparent",
  border: "none",
  cursor: "pointer",
  paddingLeft: 0,
  paddingRight: 0,
  paddingTop: 6,
  paddingBottom: 6,
  height: 37,
  display: "inline-flex",
  marginBottom: 0,
  marginTop: 0,
  alignItems: "center"
};
var button = {
  ...playerButtonStyle,
  position: "relative"
};
var PlaybackrateControl = ({ playbackRates, canvasSize }) => {
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);
  const { playbackRate } = Internals4.usePlaybackRate();
  const onClick = useCallback3((e) => {
    e.stopPropagation();
    e.preventDefault();
    setIsComponentVisible((prevIsComponentVisible) => !prevIsComponentVisible);
  }, [setIsComponentVisible]);
  return /* @__PURE__ */ jsx7("div", {
    ref,
    children: /* @__PURE__ */ jsxs5("button", {
      type: "button",
      "aria-label": "Change playback rate",
      style: button,
      onClick,
      children: [
        /* @__PURE__ */ jsxs5("div", {
          style: label,
          children: [
            playbackRate,
            "x"
          ]
        }),
        isComponentVisible && /* @__PURE__ */ jsx7(PlaybackPopup, {
          canvasSize,
          playbackRates,
          setIsComponentVisible
        })
      ]
    })
  });
};

// src/PlayerSeekBar.tsx
import { useCallback as useCallback6, useEffect as useEffect6, useMemo as useMemo6, useRef as useRef4, useState as useState8 } from "react";
import { Internals as Internals6, interpolate } from "remotion";

// src/use-player-methods.ts
import { useCallback as useCallback4, useContext as useContext2, useMemo as useMemo4, useRef as useRef3 } from "react";
import { Internals as Internals5, useRemotionEnvironment } from "remotion";
var usePlayerMethods = () => {
  const seekFrame = Internals5.Timeline.useTimelineSeekFrame();
  const {
    setPlaying,
    frameRef,
    audioAndVideoTags,
    isPlaying: readIsPlaying,
    isBuffering
  } = useContext2(Internals5.SetTimelineContext);
  const audioContext = useContext2(Internals5.SharedAudioContext);
  const audioTagsContext = useContext2(Internals5.SharedAudioTagsContext);
  const { playerMuted, mediaVolume } = useContext2(Internals5.MediaVolumeContext);
  const muted = playerMuted || mediaVolume === 0;
  const environment = useRemotionEnvironment();
  const video = Internals5.useVideo();
  const videoId = video?.id ?? null;
  const videoDurationInFrames = video?.durationInFrames ?? null;
  const config = Internals5.useUnsafeVideoConfig();
  const emitter = useContext2(PlayerEventEmitterContext);
  const playStart = useRef3(0);
  const fallbackFrame = useRef3(null);
  const nextPlayIsAutoPlayAttempt = useRef3(false);
  if (!emitter) {
    throw new TypeError("Expected Player event emitter context");
  }
  const getCurrentFrame = useCallback4(() => {
    if (videoId === null || videoDurationInFrames === null) {
      return fallbackFrame.current ?? (typeof window === "undefined" ? 0 : window.remotion_initialFrame ?? 0);
    }
    const unclamped = frameRef.current[videoId] ?? (environment.isPlayer ? 0 : Internals5.Timeline.getFrameForComposition(videoId));
    return Internals5.Timeline.clampFrameToCompositionRange(unclamped, videoDurationInFrames);
  }, [environment.isPlayer, frameRef, videoId, videoDurationInFrames]);
  const seek = useCallback4((newFrame) => {
    const frameToSeekTo = config ? Internals5.TimelinePosition.clampFrameToCompositionRange(newFrame, config.durationInFrames) : Math.max(0, newFrame);
    fallbackFrame.current = frameToSeekTo;
    if (video?.id) {
      seekFrame((currentFrames) => currentFrames[video.id] === frameToSeekTo ? currentFrames : { ...currentFrames, [video.id]: frameToSeekTo });
      if (frameRef.current[video.id] !== frameToSeekTo) {
        frameRef.current = {
          ...frameRef.current,
          [video.id]: frameToSeekTo
        };
      }
    }
    emitter.dispatchSeek(frameToSeekTo);
  }, [config, emitter, frameRef, seekFrame, video?.id]);
  const play = useCallback4((e) => {
    const isAutoPlayAttempt = nextPlayIsAutoPlayAttempt.current;
    nextPlayIsAutoPlayAttempt.current = false;
    if (readIsPlaying()) {
      return;
    }
    const lastFrameForPlayback = (config?.durationInFrames ?? 1) - 1;
    if (getCurrentFrame() === lastFrameForPlayback) {
      seek(0);
    }
    if (!muted) {
      if (isAutoPlayAttempt) {
        audioContext?.resumeAsAutoPlay();
      } else {
        audioContext?.resume();
      }
      if (audioTagsContext && audioTagsContext.numberOfAudioTags > 0 && e) {
        audioTagsContext.playAllAudios();
      }
    }
    audioAndVideoTags.current.forEach((tag) => tag.play("player play() was called and playing audio from a click"));
    setPlaying(true);
    playStart.current = getCurrentFrame();
    emitter.dispatchPlay();
  }, [
    audioAndVideoTags,
    audioContext,
    audioTagsContext,
    config?.durationInFrames,
    emitter,
    getCurrentFrame,
    muted,
    readIsPlaying,
    seek,
    setPlaying
  ]);
  const playAsAutoPlay = useCallback4(() => {
    nextPlayIsAutoPlayAttempt.current = true;
    play();
  }, [play]);
  const pause = useCallback4(() => {
    if (readIsPlaying()) {
      setPlaying(false);
      emitter.dispatchPause();
      audioContext?.suspend();
    }
  }, [audioContext, emitter, readIsPlaying, setPlaying]);
  const pauseAndReturnToPlayStart = useCallback4(() => {
    if (readIsPlaying()) {
      setPlaying(false);
      fallbackFrame.current = playStart.current;
      if (config) {
        seekFrame((currentFrames) => ({
          ...currentFrames,
          [config.id]: playStart.current
        }));
        frameRef.current = {
          ...frameRef.current,
          [config.id]: playStart.current
        };
        emitter.dispatchPause();
      }
    }
  }, [config, emitter, frameRef, readIsPlaying, setPlaying, seekFrame]);
  const lastFrame = (config?.durationInFrames ?? 1) - 1;
  const frameBack = useCallback4((frames) => {
    if (!videoId) {
      return null;
    }
    if (readIsPlaying()) {
      return;
    }
    const previousFrame = frameRef.current[videoId] ?? window.remotion_initialFrame ?? 0;
    const newFrame = Math.max(0, previousFrame - frames);
    if (previousFrame === newFrame) {
      return;
    }
    seekFrame((currentFrames) => currentFrames[videoId] === newFrame ? currentFrames : { ...currentFrames, [videoId]: newFrame });
    frameRef.current = {
      ...frameRef.current,
      [videoId]: newFrame
    };
  }, [frameRef, readIsPlaying, seekFrame, videoId]);
  const frameForward = useCallback4((frames) => {
    if (!videoId) {
      return null;
    }
    if (readIsPlaying()) {
      return;
    }
    const previousFrame = frameRef.current[videoId] ?? window.remotion_initialFrame ?? 0;
    const newFrame = Math.min(lastFrame, previousFrame + frames);
    if (previousFrame === newFrame) {
      return;
    }
    seekFrame((currentFrames) => currentFrames[videoId] === newFrame ? currentFrames : { ...currentFrames, [videoId]: newFrame });
    frameRef.current = {
      ...frameRef.current,
      [videoId]: newFrame
    };
  }, [frameRef, lastFrame, readIsPlaying, seekFrame, videoId]);
  const toggle = useCallback4((e) => {
    if (readIsPlaying()) {
      pause();
    } else {
      play(e);
    }
  }, [pause, play, readIsPlaying]);
  return useMemo4(() => {
    return {
      frameBack,
      frameForward,
      emitter,
      play,
      playAsAutoPlay,
      pause,
      seek,
      getCurrentFrame,
      isPlaying: readIsPlaying,
      isBuffering,
      pauseAndReturnToPlayStart,
      toggle
    };
  }, [
    emitter,
    frameBack,
    frameForward,
    getCurrentFrame,
    readIsPlaying,
    pause,
    pauseAndReturnToPlayStart,
    play,
    playAsAutoPlay,
    isBuffering,
    seek,
    toggle
  ]);
};

// src/utils/use-element-size.ts
import { useCallback as useCallback5, useEffect as useEffect5, useMemo as useMemo5, useState as useState7 } from "react";
var elementSizeHooks = [];
var updateAllElementsSizes = () => {
  for (const listener of elementSizeHooks) {
    listener();
  }
};
var getElement = (source) => {
  if (!source) {
    return null;
  }
  if ("current" in source) {
    return source.current;
  }
  return source;
};
var useElementSize = (source, options) => {
  const [size, setSize] = useState7(() => {
    const element = getElement(source);
    if (!element) {
      return null;
    }
    const rect = element.getClientRects();
    if (!rect[0]) {
      return null;
    }
    return {
      width: rect[0].width,
      height: rect[0].height,
      left: rect[0].x,
      top: rect[0].y,
      windowSize: {
        height: window.innerHeight,
        width: window.innerWidth
      }
    };
  });
  const observer = useMemo5(() => {
    if (typeof ResizeObserver === "undefined") {
      return null;
    }
    return new ResizeObserver((entries) => {
      const { contentRect, target } = entries[0];
      const newSize = target.getClientRects();
      if (!newSize?.[0]) {
        setSize(null);
        return;
      }
      const probableCssParentScaleX = contentRect.width === 0 ? 1 : newSize[0].width / contentRect.width;
      const probableCssParentScaleY = contentRect.height === 0 ? 1 : newSize[0].height / contentRect.height;
      const width = options.shouldApplyCssTransforms || probableCssParentScaleX === 0 ? newSize[0].width : newSize[0].width * (1 / probableCssParentScaleX);
      const height = options.shouldApplyCssTransforms || probableCssParentScaleY === 0 ? newSize[0].height : newSize[0].height * (1 / probableCssParentScaleY);
      setSize((prevState) => {
        const isSame = prevState && prevState.width === width && prevState.height === height && prevState.left === newSize[0].x && prevState.top === newSize[0].y && prevState.windowSize.height === window.innerHeight && prevState.windowSize.width === window.innerWidth;
        if (isSame) {
          return prevState;
        }
        return {
          width,
          height,
          left: newSize[0].x,
          top: newSize[0].y,
          windowSize: {
            height: window.innerHeight,
            width: window.innerWidth
          }
        };
      });
    });
  }, [options.shouldApplyCssTransforms]);
  const updateSize = useCallback5(() => {
    const element = getElement(source);
    if (!element) {
      return;
    }
    const rect = element.getClientRects();
    if (!rect[0]) {
      setSize(null);
      return;
    }
    setSize((prevState) => {
      const isSame = prevState && prevState.width === rect[0].width && prevState.height === rect[0].height && prevState.left === rect[0].x && prevState.top === rect[0].y && prevState.windowSize.height === window.innerHeight && prevState.windowSize.width === window.innerWidth;
      if (isSame) {
        return prevState;
      }
      return {
        width: rect[0].width,
        height: rect[0].height,
        left: rect[0].x,
        top: rect[0].y,
        windowSize: {
          height: window.innerHeight,
          width: window.innerWidth
        }
      };
    });
  }, [source]);
  useEffect5(() => {
    updateSize();
  }, [updateSize]);
  useEffect5(() => {
    if (!observer) {
      return;
    }
    const element = getElement(source);
    if (element) {
      observer.observe(element);
    }
    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, [observer, source]);
  useEffect5(() => {
    if (!options.triggerOnWindowResize) {
      return;
    }
    window.addEventListener("resize", updateSize);
    return () => {
      window.removeEventListener("resize", updateSize);
    };
  }, [options.triggerOnWindowResize, updateSize]);
  useEffect5(() => {
    elementSizeHooks.push(updateSize);
    return () => {
      elementSizeHooks = elementSizeHooks.filter((e) => e !== updateSize);
    };
  }, [updateSize]);
  return useMemo5(() => {
    if (!size) {
      return null;
    }
    return { ...size, refresh: updateSize };
  }, [size, updateSize]);
};

// src/PlayerSeekBar.tsx
import { jsx as jsx8, jsxs as jsxs6 } from "react/jsx-runtime";
var getFrameFromX = (clientX, durationInFrames, width) => {
  const pos = clientX;
  const frame = Math.round(interpolate(pos, [0, width], [0, durationInFrames - 1], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp"
  }));
  return frame;
};
var BAR_HEIGHT2 = 5;
var KNOB_SIZE2 = 12;
var VERTICAL_PADDING = 4;
var containerStyle = {
  userSelect: "none",
  WebkitUserSelect: "none",
  paddingTop: VERTICAL_PADDING,
  paddingBottom: VERTICAL_PADDING,
  boxSizing: "border-box",
  cursor: "pointer",
  position: "relative",
  touchAction: "none"
};
var barBackground = {
  height: BAR_HEIGHT2,
  backgroundColor: "rgba(255, 255, 255, 0.25)",
  width: "100%",
  borderRadius: BAR_HEIGHT2 / 2
};
var findBodyInWhichDivIsLocated = (div) => {
  let current = div;
  while (current.parentElement) {
    current = current.parentElement;
  }
  return current;
};
var PlayerSeekBar = ({ durationInFrames, onSeekEnd, onSeekStart, inFrame, outFrame }) => {
  const containerRef = useRef4(null);
  const barHovered = useHoverState(containerRef, false);
  const size = useElementSize(containerRef, {
    triggerOnWindowResize: true,
    shouldApplyCssTransforms: true
  });
  const { seek, play, pause, isPlaying } = usePlayerMethods();
  const frame = Internals6.Timeline.useTimelinePosition();
  const [dragging, setDragging] = useState8({
    dragging: false
  });
  const width = size?.width ?? 0;
  const onPointerDown = useCallback6((e) => {
    if (e.button !== 0) {
      return;
    }
    const posLeft = containerRef.current?.getBoundingClientRect().left;
    const _frame = getFrameFromX(e.clientX - posLeft, durationInFrames, width);
    const wasPlaying = isPlaying();
    pause();
    seek(_frame);
    setDragging({
      dragging: true,
      wasPlaying
    });
    onSeekStart();
  }, [durationInFrames, width, isPlaying, pause, seek, onSeekStart]);
  const onPointerMove = useCallback6((e) => {
    if (!size) {
      throw new Error("Player has no size");
    }
    if (!dragging.dragging) {
      return;
    }
    const posLeft = containerRef.current?.getBoundingClientRect().left;
    const _frame = getFrameFromX(e.clientX - posLeft, durationInFrames, size.width);
    seek(_frame);
  }, [dragging.dragging, durationInFrames, seek, size]);
  const onPointerUp = useCallback6(() => {
    setDragging({
      dragging: false
    });
    if (!dragging.dragging) {
      return;
    }
    if (dragging.wasPlaying) {
      play();
    } else {
      pause();
    }
    onSeekEnd();
  }, [dragging, onSeekEnd, pause, play]);
  useEffect6(() => {
    if (!dragging.dragging) {
      return;
    }
    const body = findBodyInWhichDivIsLocated(containerRef.current);
    body.addEventListener("pointermove", onPointerMove);
    body.addEventListener("pointerup", onPointerUp);
    return () => {
      body.removeEventListener("pointermove", onPointerMove);
      body.removeEventListener("pointerup", onPointerUp);
    };
  }, [dragging.dragging, onPointerMove, onPointerUp]);
  const knobStyle = useMemo6(() => {
    return {
      height: KNOB_SIZE2,
      width: KNOB_SIZE2,
      borderRadius: KNOB_SIZE2 / 2,
      position: "absolute",
      top: VERTICAL_PADDING - KNOB_SIZE2 / 2 + 5 / 2,
      backgroundColor: "white",
      left: Math.max(0, frame / Math.max(1, durationInFrames - 1) * width - KNOB_SIZE2 / 2),
      boxShadow: "0 0 2px black",
      opacity: Number(barHovered || dragging.dragging)
    };
  }, [barHovered, dragging.dragging, durationInFrames, frame, width]);
  const fillStyle = useMemo6(() => {
    return {
      height: BAR_HEIGHT2,
      backgroundColor: "rgba(255, 255, 255, 1)",
      width: (frame - (inFrame ?? 0)) / (durationInFrames - 1) * width,
      marginLeft: (inFrame ?? 0) / (durationInFrames - 1) * width,
      borderRadius: BAR_HEIGHT2 / 2
    };
  }, [durationInFrames, frame, inFrame, width]);
  const active = useMemo6(() => {
    return {
      height: BAR_HEIGHT2,
      backgroundColor: "rgba(255, 255, 255, 0.25)",
      width: ((outFrame ?? durationInFrames - 1) - (inFrame ?? 0)) / (durationInFrames - 1) * 100 + "%",
      marginLeft: (inFrame ?? 0) / (durationInFrames - 1) * 100 + "%",
      borderRadius: BAR_HEIGHT2 / 2,
      position: "absolute"
    };
  }, [durationInFrames, inFrame, outFrame]);
  return /* @__PURE__ */ jsxs6("div", {
    ref: containerRef,
    onPointerDown,
    style: containerStyle,
    children: [
      /* @__PURE__ */ jsxs6("div", {
        style: barBackground,
        children: [
          /* @__PURE__ */ jsx8("div", {
            style: active
          }),
          /* @__PURE__ */ jsx8("div", {
            style: fillStyle
          })
        ]
      }),
      /* @__PURE__ */ jsx8("div", {
        style: knobStyle
      })
    ]
  });
};

// src/PlayerTimeLabel.tsx
import { useMemo as useMemo7 } from "react";
import { Internals as Internals7 } from "remotion";

// src/format-time.ts
var formatTime = (timeInSeconds) => {
  const minutes = Math.floor(timeInSeconds / 60);
  const seconds = Math.floor(timeInSeconds - minutes * 60);
  return `${String(minutes)}:${String(seconds).padStart(2, "0")}`;
};

// src/PlayerTimeLabel.tsx
import { jsxs as jsxs7 } from "react/jsx-runtime";
var PlayerTimeLabel = ({ durationInFrames, maxTimeLabelWidth, fps }) => {
  const frame = Internals7.Timeline.useTimelinePosition();
  const timeLabel = useMemo7(() => {
    return {
      color: "white",
      fontFamily: "sans-serif",
      fontSize: 14,
      maxWidth: maxTimeLabelWidth === null ? undefined : maxTimeLabelWidth,
      overflow: "hidden",
      textOverflow: "ellipsis"
    };
  }, [maxTimeLabelWidth]);
  const isLastFrame = frame === durationInFrames - 1;
  const frameToDisplay = isLastFrame ? frame + 1 : frame;
  return /* @__PURE__ */ jsxs7("div", {
    style: timeLabel,
    children: [
      formatTime(frameToDisplay / fps),
      " / ",
      formatTime(durationInFrames / fps)
    ]
  });
};

// src/use-video-controls-resize.ts
import { useMemo as useMemo8 } from "react";
var X_SPACER = 10;
var X_PADDING = 12;
var useVideoControlsResize = ({
  allowFullscreen: allowFullScreen,
  playerWidth
}) => {
  const resizeInfo = useMemo8(() => {
    const playPauseIconSize = ICON_SIZE;
    const volumeIconSize = ICON_SIZE;
    const _fullscreenIconSize = allowFullScreen ? fullscreenIconSize : 0;
    const elementsSize = volumeIconSize + playPauseIconSize + _fullscreenIconSize + X_PADDING * 2 + X_SPACER * 2;
    const maxTimeLabelWidth = playerWidth - elementsSize;
    const maxTimeLabelWidthWithoutNegativeValue = Math.max(maxTimeLabelWidth, 0);
    const availableTimeLabelWidthIfVolumeOpen = maxTimeLabelWidthWithoutNegativeValue - VOLUME_SLIDER_WIDTH;
    const computedLabelWidth = availableTimeLabelWidthIfVolumeOpen < VOLUME_SLIDER_WIDTH ? maxTimeLabelWidthWithoutNegativeValue : availableTimeLabelWidthIfVolumeOpen;
    const minWidthForHorizontalDisplay = computedLabelWidth + elementsSize + VOLUME_SLIDER_WIDTH;
    const displayVerticalVolumeSlider = playerWidth < minWidthForHorizontalDisplay;
    return {
      maxTimeLabelWidth: maxTimeLabelWidthWithoutNegativeValue === 0 ? null : maxTimeLabelWidthWithoutNegativeValue,
      displayVerticalVolumeSlider
    };
  }, [allowFullScreen, playerWidth]);
  return resizeInfo;
};

// src/PlayerControls.tsx
import { jsx as jsx9, jsxs as jsxs8, Fragment as Fragment2 } from "react/jsx-runtime";
var gradientSteps = [
  0,
  0.013,
  0.049,
  0.104,
  0.175,
  0.259,
  0.352,
  0.45,
  0.55,
  0.648,
  0.741,
  0.825,
  0.896,
  0.951,
  0.987
];
var gradientOpacities = [
  0,
  8.1,
  15.5,
  22.5,
  29,
  35.3,
  41.2,
  47.1,
  52.9,
  58.8,
  64.7,
  71,
  77.5,
  84.5,
  91.9
];
var globalGradientOpacity = 1 / 0.7;
var containerStyle2 = {
  boxSizing: "border-box",
  position: "absolute",
  bottom: 0,
  width: "100%",
  paddingTop: 40,
  paddingBottom: 10,
  backgroundImage: `linear-gradient(to bottom,${gradientSteps.map((g, i) => {
    return `hsla(0, 0%, 0%, ${g}) ${gradientOpacities[i] * globalGradientOpacity}%`;
  }).join(", ")}, hsl(0, 0%, 0%) 100%)`,
  backgroundSize: "auto 145px",
  display: "flex",
  paddingRight: X_PADDING,
  paddingLeft: X_PADDING,
  flexDirection: "column",
  transition: "opacity 0.3s"
};
var controlsRow = {
  display: "flex",
  flexDirection: "row",
  width: "100%",
  alignItems: "center",
  justifyContent: "center",
  userSelect: "none",
  WebkitUserSelect: "none"
};
var leftPartStyle = {
  display: "flex",
  flexDirection: "row",
  userSelect: "none",
  WebkitUserSelect: "none",
  alignItems: "center"
};
var xSpacer = {
  width: 12
};
var ySpacer = {
  height: 8
};
var flex1 = {
  flex: 1
};
var fullscreen = {};
var Controls = ({
  durationInFrames,
  isFullscreen,
  fps,
  showVolumeControls,
  onFullscreenButtonClick,
  allowFullscreen,
  onExitFullscreenButtonClick,
  spaceKeyToPlayOrPause,
  onSeekEnd,
  onSeekStart,
  inFrame,
  outFrame,
  initiallyShowControls,
  canvasSize,
  renderPlayPauseButton,
  renderFullscreenButton,
  alwaysShowControls,
  showPlaybackRateControl,
  containerRef,
  buffering,
  hideControlsWhenPointerDoesntMove,
  onPointerDown,
  onDoubleClick,
  renderMuteButton,
  renderVolumeSlider,
  playing,
  toggle,
  renderCustomControls
}) => {
  const playButtonRef = useRef5(null);
  const [supportsFullscreen, setSupportsFullscreen] = useState9(false);
  const hovered = useHoverState(containerRef, hideControlsWhenPointerDoesntMove);
  const { maxTimeLabelWidth, displayVerticalVolumeSlider } = useVideoControlsResize({
    allowFullscreen,
    playerWidth: canvasSize?.width ?? 0
  });
  const [shouldShowInitially, setInitiallyShowControls] = useState9(() => {
    if (typeof initiallyShowControls === "boolean") {
      return initiallyShowControls;
    }
    if (typeof initiallyShowControls === "number") {
      if (initiallyShowControls % 1 !== 0) {
        throw new Error("initiallyShowControls must be an integer or a boolean");
      }
      if (Number.isNaN(initiallyShowControls)) {
        throw new Error("initiallyShowControls must not be NaN");
      }
      if (!Number.isFinite(initiallyShowControls)) {
        throw new Error("initiallyShowControls must be finite");
      }
      if (initiallyShowControls <= 0) {
        throw new Error("initiallyShowControls must be a positive integer");
      }
      return initiallyShowControls;
    }
    throw new TypeError("initiallyShowControls must be a number or a boolean");
  });
  const containerCss = useMemo9(() => {
    const shouldShow = hovered || !playing || shouldShowInitially || alwaysShowControls;
    return {
      ...containerStyle2,
      opacity: Number(shouldShow)
    };
  }, [hovered, shouldShowInitially, playing, alwaysShowControls]);
  useEffect7(() => {
    if (playButtonRef.current && spaceKeyToPlayOrPause) {
      playButtonRef.current.focus({
        preventScroll: true
      });
    }
  }, [playing, spaceKeyToPlayOrPause]);
  useEffect7(() => {
    setSupportsFullscreen((typeof document !== "undefined" && (document.fullscreenEnabled || document.webkitFullscreenEnabled)) ?? false);
  }, []);
  useEffect7(() => {
    if (shouldShowInitially === false) {
      return;
    }
    const time = shouldShowInitially === true ? 2000 : shouldShowInitially;
    const timeout = setTimeout(() => {
      setInitiallyShowControls(false);
    }, time);
    return () => {
      clearInterval(timeout);
    };
  }, [shouldShowInitially]);
  const playbackRates = useMemo9(() => {
    if (showPlaybackRateControl === true) {
      return [0.5, 0.8, 1, 1.2, 1.5, 1.8, 2, 2.5, 3];
    }
    if (Array.isArray(showPlaybackRateControl)) {
      for (const rate of showPlaybackRateControl) {
        if (typeof rate !== "number") {
          throw new Error("Every item in showPlaybackRateControl must be a number");
        }
        if (rate <= 0) {
          throw new Error("Every item in showPlaybackRateControl must be positive");
        }
      }
      return showPlaybackRateControl;
    }
    return null;
  }, [showPlaybackRateControl]);
  const customControlsElement = renderCustomControls ? renderCustomControls() : null;
  const ref = useRef5(null);
  const flexRef = useRef5(null);
  const onPointerDownIfContainer = useCallback7((e) => {
    if (e.target === ref.current || e.target === flexRef.current) {
      onPointerDown?.(e);
    }
  }, [onPointerDown]);
  const onDoubleClickIfContainer = useCallback7((e) => {
    if (e.target === ref.current || e.target === flexRef.current) {
      onDoubleClick?.(e);
    }
  }, [onDoubleClick]);
  return /* @__PURE__ */ jsxs8("div", {
    ref,
    style: containerCss,
    onPointerDown: onPointerDownIfContainer,
    onDoubleClick: onDoubleClickIfContainer,
    children: [
      /* @__PURE__ */ jsxs8("div", {
        ref: flexRef,
        style: controlsRow,
        children: [
          /* @__PURE__ */ jsxs8("div", {
            style: leftPartStyle,
            children: [
              /* @__PURE__ */ jsx9("button", {
                ref: playButtonRef,
                type: "button",
                style: playerButtonStyle,
                onClick: toggle,
                "aria-label": playing ? "Pause video" : "Play video",
                title: playing ? "Pause video" : "Play video",
                children: renderPlayPauseButton === null ? /* @__PURE__ */ jsx9(DefaultPlayPauseButton, {
                  buffering,
                  playing
                }) : renderPlayPauseButton({
                  playing,
                  isBuffering: buffering
                }) ?? /* @__PURE__ */ jsx9(DefaultPlayPauseButton, {
                  buffering,
                  playing
                })
              }),
              showVolumeControls ? /* @__PURE__ */ jsxs8(Fragment2, {
                children: [
                  /* @__PURE__ */ jsx9("div", {
                    style: xSpacer
                  }),
                  /* @__PURE__ */ jsx9(MediaVolumeSlider, {
                    renderMuteButton,
                    renderVolumeSlider,
                    displayVerticalVolumeSlider
                  })
                ]
              }) : null,
              /* @__PURE__ */ jsx9("div", {
                style: xSpacer
              }),
              /* @__PURE__ */ jsx9(PlayerTimeLabel, {
                durationInFrames,
                fps,
                maxTimeLabelWidth
              }),
              /* @__PURE__ */ jsx9("div", {
                style: xSpacer
              })
            ]
          }),
          /* @__PURE__ */ jsx9("div", {
            style: flex1
          }),
          customControlsElement,
          customControlsElement && playbackRates && canvasSize ? /* @__PURE__ */ jsx9("div", {
            style: xSpacer
          }) : null,
          playbackRates && canvasSize && /* @__PURE__ */ jsx9(PlaybackrateControl, {
            canvasSize,
            playbackRates
          }),
          playbackRates && supportsFullscreen && allowFullscreen ? /* @__PURE__ */ jsx9("div", {
            style: xSpacer
          }) : null,
          /* @__PURE__ */ jsx9("div", {
            style: fullscreen,
            children: supportsFullscreen && allowFullscreen ? /* @__PURE__ */ jsx9("button", {
              type: "button",
              "aria-label": isFullscreen ? "Exit fullscreen" : "Enter Fullscreen",
              title: isFullscreen ? "Exit fullscreen" : "Enter Fullscreen",
              style: playerButtonStyle,
              onClick: isFullscreen ? onExitFullscreenButtonClick : onFullscreenButtonClick,
              children: renderFullscreenButton === null ? /* @__PURE__ */ jsx9(FullscreenIcon, {
                isFullscreen
              }) : renderFullscreenButton({ isFullscreen })
            }) : null
          })
        ]
      }),
      /* @__PURE__ */ jsx9("div", {
        style: ySpacer
      }),
      /* @__PURE__ */ jsx9(PlayerSeekBar, {
        onSeekEnd,
        onSeekStart,
        durationInFrames,
        inFrame,
        outFrame
      })
    ]
  });
};

// src/timeline-sequence-observer-context.ts
import React8 from "react";
var TimelineSequenceObserverContext = React8.createContext(null);

// src/use-playback.ts
import { useLayoutEffect as useLayoutEffect2 } from "react";
import { useContext as useContext3, useEffect as useEffect10, useRef as useRef8 } from "react";
import { Internals as Internals10 } from "remotion";

// src/browser-mediasession.ts
import { useEffect as useEffect8, useRef as useRef6 } from "react";
import { Internals as Internals8 } from "remotion";
var useBrowserMediaSession = ({
  browserMediaControlsBehavior,
  videoConfig,
  playbackRate
}) => {
  const playing = Internals8.usePlaying();
  const { pause, play, emitter, getCurrentFrame, seek } = usePlayerMethods();
  const hasEverPlayed = useRef6(false);
  useEffect8(() => {
    if (playing) {
      hasEverPlayed.current = true;
    }
    if (!navigator.mediaSession) {
      return;
    }
    if (browserMediaControlsBehavior.mode === "do-nothing") {
      return;
    }
    if (playing) {
      navigator.mediaSession.playbackState = "playing";
    } else if (hasEverPlayed.current) {
      navigator.mediaSession.playbackState = "paused";
    }
  }, [browserMediaControlsBehavior.mode, playing]);
  useEffect8(() => {
    if (!navigator.mediaSession) {
      return;
    }
    if (browserMediaControlsBehavior.mode === "do-nothing") {
      return;
    }
    const onTimeUpdate = () => {
      if (!videoConfig) {
        return;
      }
      if (navigator.mediaSession) {
        navigator.mediaSession.setPositionState({
          duration: videoConfig.durationInFrames / videoConfig.fps,
          playbackRate,
          position: getCurrentFrame() / videoConfig.fps
        });
      }
    };
    emitter.addEventListener("timeupdate", onTimeUpdate);
    return () => {
      emitter.removeEventListener("timeupdate", onTimeUpdate);
    };
  }, [
    browserMediaControlsBehavior.mode,
    emitter,
    getCurrentFrame,
    playbackRate,
    videoConfig
  ]);
  useEffect8(() => {
    if (!navigator.mediaSession) {
      return;
    }
    if (browserMediaControlsBehavior.mode === "do-nothing") {
      return;
    }
    navigator.mediaSession.setActionHandler("play", () => {
      if (browserMediaControlsBehavior.mode === "register-media-session") {
        play();
      }
    });
    navigator.mediaSession.setActionHandler("pause", () => {
      if (browserMediaControlsBehavior.mode === "register-media-session") {
        pause();
      }
    });
    navigator.mediaSession.setActionHandler("seekto", (event) => {
      if (browserMediaControlsBehavior.mode === "register-media-session" && event.seekTime !== undefined && videoConfig) {
        seek(Math.round(event.seekTime * videoConfig.fps));
      }
    });
    navigator.mediaSession.setActionHandler("seekbackward", () => {
      if (browserMediaControlsBehavior.mode === "register-media-session" && videoConfig) {
        seek(Math.max(0, Math.round(getCurrentFrame() - 10 * videoConfig.fps)));
      }
    });
    navigator.mediaSession.setActionHandler("seekforward", () => {
      if (browserMediaControlsBehavior.mode === "register-media-session" && videoConfig) {
        seek(Math.min(videoConfig.durationInFrames - 1, Math.round(getCurrentFrame() + 10 * videoConfig.fps)));
      }
    });
    navigator.mediaSession.setActionHandler("previoustrack", () => {
      if (browserMediaControlsBehavior.mode === "register-media-session") {
        seek(0);
      }
    });
    return () => {
      navigator.mediaSession.metadata = null;
      navigator.mediaSession.setActionHandler("play", null);
      navigator.mediaSession.setActionHandler("pause", null);
      navigator.mediaSession.setActionHandler("seekto", null);
      navigator.mediaSession.setActionHandler("seekbackward", null);
      navigator.mediaSession.setActionHandler("seekforward", null);
      navigator.mediaSession.setActionHandler("previoustrack", null);
    };
  }, [
    browserMediaControlsBehavior.mode,
    getCurrentFrame,
    pause,
    play,
    seek,
    videoConfig
  ]);
};

// src/calculate-next-frame.ts
var calculateNextFrame = ({
  time,
  currentFrame: startFrame,
  playbackSpeed,
  fps,
  actualLastFrame,
  actualFirstFrame,
  framesAdvanced,
  shouldLoop
}) => {
  const op = playbackSpeed < 0 ? Math.ceil : Math.floor;
  const framesToAdvance = op(time * playbackSpeed / (1000 / fps)) - framesAdvanced;
  const nextFrame = framesToAdvance + startFrame;
  const isCurrentFrameOutside = startFrame > actualLastFrame || startFrame < actualFirstFrame;
  const isNextFrameOutside = nextFrame > actualLastFrame || nextFrame < actualFirstFrame;
  const hasEnded = !shouldLoop && isNextFrameOutside && !isCurrentFrameOutside;
  if (playbackSpeed > 0) {
    if (isNextFrameOutside) {
      return {
        nextFrame: actualFirstFrame,
        framesToAdvance,
        hasEnded
      };
    }
    return { nextFrame, framesToAdvance, hasEnded };
  }
  if (isNextFrameOutside) {
    return { nextFrame: actualLastFrame, framesToAdvance, hasEnded };
  }
  return { nextFrame, framesToAdvance, hasEnded };
};

// src/is-backgrounded.ts
import { useEffect as useEffect9, useRef as useRef7 } from "react";
var getIsBackgrounded = () => {
  if (typeof document === "undefined") {
    return false;
  }
  return document.visibilityState === "hidden";
};
var useIsBackgrounded = () => {
  const isBackgrounded = useRef7(getIsBackgrounded());
  useEffect9(() => {
    const onVisibilityChange = () => {
      isBackgrounded.current = getIsBackgrounded();
    };
    document.addEventListener("visibilitychange", onVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, []);
  return isBackgrounded;
};

// src/set-global-time-anchor.ts
import { Internals as Internals9 } from "remotion";
var setGlobalTimeAnchor = ({
  audioContext,
  audioSyncAnchor,
  absoluteTimeInSeconds,
  globalPlaybackRate,
  logLevel,
  force
}) => {
  const newAnchor = audioContext.currentTime - absoluteTimeInSeconds / globalPlaybackRate;
  const shift = newAnchor - audioSyncAnchor.value;
  const tolerance = Internals9.getAudioSyncAnchorTolerance(audioContext);
  if (Math.abs(shift) < tolerance && !force) {
    return false;
  }
  if (Math.abs(shift) < Number.EPSILON) {
    return false;
  }
  Internals9.Log.verbose({ logLevel, tag: "audio-scheduling" }, "Anchor " + (force ? "forcibly " : "") + "changed from %s to %s with shift %s", audioSyncAnchor.value, newAnchor, shift);
  audioSyncAnchor.value = newAnchor;
  return true;
};

// src/use-playback.ts
var shouldForceAnchorChange = (newState) => {
  if (newState === "suspended" || newState === "running-to-suspended") {
    return true;
  }
  if (newState === "closed" || newState === "interrupted" || newState === "running" || newState === "suspended-to-running") {
    return false;
  }
  throw new Error(`Unexpected audio context state: ${newState}`);
};
var usePlayback = ({
  loop,
  playbackRate,
  moveToBeginningWhenEnded,
  inFrame,
  outFrame,
  browserMediaControlsBehavior,
  getCurrentFrame,
  muted
}) => {
  const config = Internals10.useUnsafeVideoConfig();
  const fps = config?.fps ?? null;
  const durationInFrames = config?.durationInFrames ?? null;
  const compositionId = config?.id ?? null;
  const frame = Internals10.Timeline.useTimelinePosition();
  const playing = Internals10.usePlaying();
  const { pause, emitter, isPlaying } = usePlayerMethods();
  const setFrameFromPlayback = Internals10.Timeline.useTimelineSetFrameWithoutSeek();
  const sharedAudioContext = useContext3(Internals10.SharedAudioContext);
  const { setPlayerMuted } = useContext3(Internals10.SetMediaVolumeContext);
  const { isBuffering, subscribeBuffering, seek } = useContext3(Internals10.SetTimelineContext);
  const logLevel = Internals10.useLogLevel();
  const isBackgroundedRef = useIsBackgrounded();
  const lastTimeUpdateTimestamp = useRef8(0);
  const playbackClockRef = useRef8(null);
  const previousMutedRef = useRef8(muted);
  const anchoredAudioContextRef = useRef8(null);
  useBrowserMediaSession({
    browserMediaControlsBehavior,
    playbackRate,
    videoConfig: config
  });
  useLayoutEffect2(() => {
    if (!sharedAudioContext) {
      return;
    }
    if (!sharedAudioContext.audioContext) {
      return;
    }
    if (fps === null) {
      return;
    }
    if (muted) {
      return;
    }
    const changed = setGlobalTimeAnchor({
      audioContext: sharedAudioContext.audioContext,
      audioSyncAnchor: sharedAudioContext.audioSyncAnchor,
      absoluteTimeInSeconds: frame / fps,
      globalPlaybackRate: playbackRate,
      logLevel,
      force: false
    });
    if (changed) {
      sharedAudioContext.audioSyncAnchorEmitter.dispatch("changed");
    }
  }, [fps, frame, logLevel, playbackRate, sharedAudioContext, muted]);
  useLayoutEffect2(() => {
    const audioContext = sharedAudioContext?.audioContext;
    if (!audioContext) {
      return;
    }
    if (fps === null) {
      return;
    }
    if (muted) {
      return;
    }
    const callback = () => {
      const newState = sharedAudioContext?.getAudioContextState();
      if (newState && shouldForceAnchorChange(newState)) {
        const changed = setGlobalTimeAnchor({
          audioContext,
          audioSyncAnchor: sharedAudioContext.audioSyncAnchor,
          absoluteTimeInSeconds: getCurrentFrame() / fps,
          globalPlaybackRate: playbackRate,
          logLevel,
          force: true
        });
        if (changed) {
          sharedAudioContext.audioSyncAnchorEmitter.dispatch("changed");
        }
      }
    };
    audioContext?.addEventListener("statechange", callback);
    return () => {
      audioContext?.removeEventListener("statechange", callback);
    };
  }, [fps, getCurrentFrame, logLevel, muted, playbackRate, sharedAudioContext]);
  useEffect10(() => {
    const wasMuted = previousMutedRef.current;
    previousMutedRef.current = muted;
    if (fps === null || durationInFrames === null || compositionId === null) {
      playbackClockRef.current = null;
      return;
    }
    if (!playing) {
      playbackClockRef.current = null;
      sharedAudioContext?.suspend?.();
      return;
    }
    if (muted) {
      sharedAudioContext?.suspend?.();
    }
    const previousClock = playbackClockRef.current;
    const shouldRestartClock = previousClock === null || previousClock.compositionId !== compositionId || previousClock.fps !== fps || previousClock.playbackRate !== playbackRate;
    const clock = shouldRestartClock ? {
      compositionId,
      startedTime: performance.now(),
      framesAdvanced: 0,
      fps,
      playbackRate
    } : previousClock;
    playbackClockRef.current = clock;
    if (sharedAudioContext?._experimentalKeepAudioContextAlive && sharedAudioContext.audioContext && !muted) {
      const didUnmute = wasMuted && !muted;
      const didReplaceAudioContext = anchoredAudioContextRef.current !== sharedAudioContext.audioContext;
      const shouldRescheduleAudio = shouldRestartClock || didUnmute || didReplaceAudioContext;
      const changed = setGlobalTimeAnchor({
        audioContext: sharedAudioContext.audioContext,
        audioSyncAnchor: sharedAudioContext.audioSyncAnchor,
        absoluteTimeInSeconds: getCurrentFrame() / fps,
        globalPlaybackRate: playbackRate,
        logLevel,
        force: shouldRescheduleAudio
      });
      anchoredAudioContextRef.current = sharedAudioContext.audioContext;
      if (changed || shouldRescheduleAudio) {
        sharedAudioContext.audioSyncAnchorEmitter.dispatch("changed");
      }
    }
    let hasBeenStopped = false;
    let audioContextFailed = false;
    let reqAnimFrameCall = null;
    let playbackFrame = getCurrentFrame();
    let lastSeekRevision = seek?.revision.current ?? null;
    const cancelQueuedFrame = () => {
      if (reqAnimFrameCall !== null) {
        if (reqAnimFrameCall.type === "raf") {
          cancelAnimationFrame(reqAnimFrameCall.id);
        } else {
          clearTimeout(reqAnimFrameCall.id);
        }
      }
    };
    const stop = () => {
      hasBeenStopped = true;
      cancelQueuedFrame();
    };
    const callback = () => {
      if (hasBeenStopped) {
        return;
      }
      if (!isPlaying()) {
        sharedAudioContext?.suspend?.();
        return;
      }
      if (!muted && !audioContextFailed && !isBuffering()) {
        sharedAudioContext?.resume?.();
      }
      const time = performance.now() - clock.startedTime;
      const actualLastFrame = outFrame ?? durationInFrames - 1;
      const actualFirstFrame = inFrame ?? 0;
      const seekRevision = seek?.revision.current ?? null;
      if (seekRevision !== lastSeekRevision) {
        playbackFrame = getCurrentFrame();
        lastSeekRevision = seekRevision;
      }
      const currentFrame = playbackFrame;
      const { nextFrame, framesToAdvance, hasEnded } = calculateNextFrame({
        time,
        currentFrame,
        playbackSpeed: playbackRate,
        fps,
        actualFirstFrame,
        actualLastFrame,
        framesAdvanced: clock.framesAdvanced,
        shouldLoop: loop
      });
      clock.framesAdvanced += framesToAdvance;
      const frameToDisplay = hasEnded && !moveToBeginningWhenEnded ? playbackRate > 0 ? actualLastFrame : actualFirstFrame : nextFrame;
      if (frameToDisplay !== currentFrame && !isBuffering()) {
        playbackFrame = frameToDisplay;
        setFrameFromPlayback((c) => ({ ...c, [compositionId]: frameToDisplay }));
      }
      if (hasEnded) {
        stop();
        pause();
        emitter.dispatchEnded();
        return;
      }
      queueNextFrame();
    };
    const queueNextFrame = () => {
      if (hasBeenStopped) {
        return;
      }
      const getIsResumingAudioContext = audioContextFailed ? null : sharedAudioContext?.getIsResumingAudioContext?.() ?? null;
      if (getIsResumingAudioContext !== null && !muted) {
        getIsResumingAudioContext.then((result) => {
          if (hasBeenStopped) {
            return;
          }
          if (result === "failed") {
            audioContextFailed = true;
            sharedAudioContext?.suspend();
            setPlayerMuted(true);
          }
          clock.startedTime = performance.now();
          clock.framesAdvanced = 0;
          queueNextFrame();
        });
        return;
      }
      if (isBuffering()) {
        if (!muted && !audioContextFailed) {
          sharedAudioContext?.suspend?.();
        }
        const unsubscribe = subscribeBuffering((state) => {
          if (state.buffering) {
            return;
          }
          unsubscribe();
          if (!muted && !audioContextFailed && sharedAudioContext?._experimentalKeepAudioContextAlive) {
            sharedAudioContext.resume();
          }
          clock.startedTime = performance.now();
          clock.framesAdvanced = 0;
          queueNextFrame();
        });
        return;
      }
      if (isBackgroundedRef.current) {
        reqAnimFrameCall = {
          type: "timeout",
          id: setTimeout(callback, 1000 / fps)
        };
        return;
      }
      reqAnimFrameCall = { type: "raf", id: requestAnimationFrame(callback) };
    };
    queueNextFrame();
    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        return;
      }
      cancelQueuedFrame();
      callback();
    };
    window.addEventListener("visibilitychange", onVisibilityChange);
    return () => {
      window.removeEventListener("visibilitychange", onVisibilityChange);
      stop();
    };
  }, [
    compositionId,
    durationInFrames,
    fps,
    loop,
    pause,
    playing,
    setFrameFromPlayback,
    emitter,
    playbackRate,
    inFrame,
    outFrame,
    moveToBeginningWhenEnded,
    isBackgroundedRef,
    getCurrentFrame,
    isBuffering,
    isPlaying,
    sharedAudioContext,
    setPlayerMuted,
    subscribeBuffering,
    seek,
    logLevel,
    muted
  ]);
  useEffect10(() => {
    const now = performance.now();
    const timeSinceLastUpdate = now - lastTimeUpdateTimestamp.current;
    if (timeSinceLastUpdate >= 250) {
      emitter.dispatchTimeUpdate({ frame });
      lastTimeUpdateTimestamp.current = now;
      return;
    }
    const timeoutId = setTimeout(() => {
      emitter.dispatchTimeUpdate({ frame });
      lastTimeUpdateTimestamp.current = performance.now();
    }, 250 - timeSinceLastUpdate);
    return () => clearTimeout(timeoutId);
  }, [emitter, frame]);
  useEffect10(() => {
    emitter.dispatchFrameUpdate({ frame });
  }, [emitter, frame]);
};

// src/Player.tsx
import React13, {
  forwardRef as forwardRef2,
  useCallback as useCallback12,
  useEffect as useEffect13,
  useImperativeHandle as useImperativeHandle2,
  useLayoutEffect as useLayoutEffect3,
  useMemo as useMemo14,
  useRef as useRef12,
  useState as useState12
} from "react";
import { Composition, Internals as Internals15 } from "remotion";
import { NoReactInternals as NoReactInternals2 } from "remotion/no-react";

// src/player-css-classname.ts
var playerCssClassname = (override) => {
  return override ?? "__remotion-player";
};

// src/PlayerUI.tsx
import React11, {
  Suspense,
  forwardRef,
  useCallback as useCallback10,
  useContext as useContext4,
  useEffect as useEffect12,
  useImperativeHandle,
  useMemo as useMemo12,
  useRef as useRef10,
  useState as useState10
} from "react";
import { Internals as Internals11 } from "remotion";

// src/error-boundary.tsx
import React9 from "react";
import { jsx as jsx10 } from "react/jsx-runtime";
var errorStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flex: 1,
  height: "100%",
  width: "100%"
};

class ErrorBoundary extends React9.Component {
  state = { hasError: null };
  static getDerivedStateFromError(error) {
    return { hasError: error };
  }
  componentDidCatch(error) {
    this.props.onError(error);
  }
  render() {
    if (this.state.hasError) {
      return /* @__PURE__ */ jsx10("div", {
        style: errorStyle,
        children: this.props.errorFallback({
          error: this.state.hasError
        })
      });
    }
    return this.props.children;
  }
}

// src/license-blacklist.tsx
import React10, { useEffect as useEffect11 } from "react";
import { jsx as jsx11 } from "react/jsx-runtime";
var getHashOfDomain = async () => {
  if (typeof window === "undefined") {
    return null;
  }
  if (typeof window.crypto === "undefined") {
    return null;
  }
  if (typeof window.crypto.subtle === "undefined") {
    return null;
  }
  try {
    const hashBuffer = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(window.location.hostname));
    return Array.from(new Uint8Array(hashBuffer)).map((b) => b.toString(16).padStart(2, "0")).join("");
  } catch {
    return null;
  }
};
var style = {
  backgroundColor: "red",
  position: "absolute",
  padding: 12,
  fontFamily: "Arial"
};
var DOMAIN_BLACKLIST = [
  "28d262b44cc61fa750f1686b16ad0604dabfe193fbc263eec05c89b7ad4c2cd6",
  "4db1b0a94be33165dfefcb3ba03d04c7a2666dd27c496d3dc9fa41858e94925e",
  "fbc48530bbf245da790f63675e84e06bab38c3b114fab07eb350025119922bdc",
  "7baf10a8932757b1b3a22b3fce10a048747ac2f8eaf638603487e3705b07eb83",
  "8a6c21a598d8c667272b5207c051b85997bf5b45d5fb712378be3f27cd72c6a6",
  "a2f7aaac9c50a9255e7fc376110c4e0bfe153722dc66ed3c5d3bf2a135f65518"
];
var ran = false;
var RenderWarningIfBlacklist = () => {
  const [unlicensed, setUnlicensed] = React10.useState(false);
  useEffect11(() => {
    if (ran) {
      return;
    }
    ran = true;
    getHashOfDomain().then((hash) => {
      if (hash && DOMAIN_BLACKLIST.includes(hash)) {
        setUnlicensed(true);
      }
    }).catch(() => {});
  }, []);
  useEffect11(() => {
    if (!unlicensed) {
      return;
    }
    const ensureBanner = () => {
      const banner = document.querySelector(".warning-banner");
      if (!banner) {
        const div = document.createElement("div");
        div.className = "warning-banner";
        Object.assign(div.style, style, {
          zIndex: "9999",
          cssText: `${style.cssText} !important;`
        });
        div.innerHTML = `
	        <a href="https://github.com/remotion-dev/remotion/pull/4589" style="color: white;">
	          Remotion Unlicensed – Contact hi@remotion.dev
	        </a>
	      `;
        document.body.appendChild(div);
      }
    };
    const observer = new MutationObserver(() => ensureBanner());
    observer.observe(document.body, { childList: true, subtree: true });
    return () => {
      observer.disconnect();
    };
  }, [unlicensed]);
  if (!unlicensed) {
    return null;
  }
  return /* @__PURE__ */ jsx11("div", {
    style,
    className: "warning-banner",
    children: /* @__PURE__ */ jsx11("a", {
      style: { color: "white" },
      href: "https://github.com/remotion-dev/remotion/pull/4589",
      children: "Remotion Unlicensed – Contact hi@remotion.dev"
    })
  });
};

// src/utils/is-node.ts
var IS_NODE = typeof document === "undefined";

// src/utils/use-click-prevention-on-double-click.ts
import { useCallback as useCallback9, useMemo as useMemo11 } from "react";

// src/utils/cancellable-promise.ts
var cancellablePromise = (promise) => {
  let isCanceled = false;
  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then((value) => {
      if (isCanceled) {
        reject({ isCanceled, value });
        return;
      }
      resolve(value);
    }).catch((error) => {
      reject({ isCanceled, error });
    });
  });
  return {
    promise: wrappedPromise,
    cancel: () => {
      isCanceled = true;
    }
  };
};

// src/utils/delay.ts
var delay = (n) => new Promise((resolve) => setTimeout(resolve, n));

// src/utils/use-cancellable-promises.ts
import { useCallback as useCallback8, useMemo as useMemo10, useRef as useRef9 } from "react";
var useCancellablePromises = () => {
  const pendingPromises = useRef9([]);
  const appendPendingPromise = useCallback8((promise) => {
    pendingPromises.current = [...pendingPromises.current, promise];
  }, []);
  const removePendingPromise = useCallback8((promise) => {
    pendingPromises.current = pendingPromises.current.filter((p) => p !== promise);
  }, []);
  const clearPendingPromises = useCallback8(() => pendingPromises.current.map((p) => p.cancel()), []);
  const api = useMemo10(() => ({
    appendPendingPromise,
    removePendingPromise,
    clearPendingPromises
  }), [appendPendingPromise, clearPendingPromises, removePendingPromise]);
  return api;
};

// src/utils/use-click-prevention-on-double-click.ts
var useClickPreventionOnDoubleClick = (onClick, onDoubleClick, doubleClickToFullscreen) => {
  const api = useCancellablePromises();
  const handleClick = useCallback9(async (e) => {
    if (e instanceof PointerEvent ? e.pointerType === "touch" : e.nativeEvent.pointerType === "touch") {
      onClick(e);
      return;
    }
    api.clearPendingPromises();
    const waitForClick = cancellablePromise(delay(200));
    api.appendPendingPromise(waitForClick);
    try {
      await waitForClick.promise;
      api.removePendingPromise(waitForClick);
      onClick(e);
    } catch (errorInfo) {
      const info = errorInfo;
      api.removePendingPromise(waitForClick);
      if (!info.isCanceled) {
        throw info.error;
      }
    }
  }, [api, onClick]);
  const handlePointerDown = useCallback9(() => {
    document.addEventListener("pointerup", (newEvt) => {
      handleClick(newEvt);
    }, {
      once: true
    });
  }, [handleClick]);
  const handleDoubleClick = useCallback9(() => {
    api.clearPendingPromises();
    onDoubleClick();
  }, [api, onDoubleClick]);
  const returnValue = useMemo11(() => {
    if (!doubleClickToFullscreen) {
      return { handlePointerDown: onClick, handleDoubleClick: () => {
        return;
      } };
    }
    return { handlePointerDown, handleDoubleClick };
  }, [doubleClickToFullscreen, handleDoubleClick, handlePointerDown, onClick]);
  return returnValue;
};

// src/PlayerUI.tsx
import { jsx as jsx12, jsxs as jsxs9, Fragment as Fragment3 } from "react/jsx-runtime";
var reactVersion = React11.version.split(".")[0];
if (reactVersion === "0") {
  throw new Error(`Version ${reactVersion} of "react" is not supported by Remotion`);
}
var doesReactVersionSupportSuspense = parseInt(reactVersion, 10) >= 18;
var PlayerUI = ({
  controls,
  style,
  loop,
  autoPlay,
  allowFullscreen,
  inputProps,
  clickToPlay,
  showVolumeControls,
  doubleClickToFullscreen,
  spaceKeyToPlayOrPause,
  errorFallback,
  playbackRate,
  renderLoading,
  renderPoster,
  className,
  moveToBeginningWhenEnded,
  showPosterWhenUnplayed,
  showPosterWhenEnded,
  showPosterWhenPaused,
  showPosterWhenBuffering,
  showPosterWhenBufferingAndPaused,
  inFrame,
  outFrame,
  initiallyShowControls,
  renderFullscreen: renderFullscreenButton,
  renderPlayPauseButton,
  renderMuteButton,
  renderVolumeSlider,
  renderCustomControls,
  alwaysShowControls,
  showPlaybackRateControl,
  posterFillMode,
  bufferStateDelayInMilliseconds,
  hideControlsWhenPointerDoesntMove,
  overflowVisible,
  browserMediaControlsBehavior,
  overrideInternalClassName,
  noSuspense
}, ref) => {
  const config = Internals11.useUnsafeVideoConfig();
  const video = Internals11.useVideo();
  const container = useRef10(null);
  const canvasSize = useElementSize(container, {
    triggerOnWindowResize: false,
    shouldApplyCssTransforms: false
  });
  const [hasPausedToResume, setHasPausedToResume] = useState10(false);
  const [shouldAutoplay, setShouldAutoPlay] = useState10(autoPlay);
  const [isFullscreen, setIsFullscreen] = useState10(() => false);
  const [seeking, setSeeking] = useState10(false);
  const [hasPlayed, setHasPlayed] = useState10(false);
  const supportsFullScreen = useMemo12(() => {
    if (typeof document === "undefined") {
      return false;
    }
    return Boolean(document.fullscreenEnabled || document.webkitFullscreenEnabled);
  }, []);
  const player = usePlayerMethods();
  const playing = Internals11.usePlaying();
  const frame = Internals11.Timeline.useTimelinePosition();
  const play = useCallback10((e) => {
    if (player.isPlaying()) {
      return;
    }
    setHasPlayed(true);
    player.play(e);
  }, [player]);
  const [playerMuted, setPlayerMuted] = Internals11.usePlayerMutedState();
  const [mediaVolume, setMediaVolume] = Internals11.useMediaVolumeState();
  const canvasOverlay = useContext4(CanvasOverlayContext);
  const canvasContentRef = useRef10(null);
  useEffect12(() => {
    player.emitter.dispatchVolumeChange(mediaVolume);
  }, [player.emitter, mediaVolume]);
  const isMuted = playerMuted || mediaVolume === 0;
  useEffect12(() => {
    player.emitter.dispatchMuteChange({
      isMuted
    });
  }, [player.emitter, isMuted]);
  usePlayback({
    loop,
    playbackRate,
    moveToBeginningWhenEnded,
    inFrame,
    outFrame,
    getCurrentFrame: player.getCurrentFrame,
    browserMediaControlsBehavior,
    muted: isMuted
  });
  useEffect12(() => {
    if (hasPausedToResume && !playing) {
      setHasPausedToResume(false);
      play();
    }
  }, [hasPausedToResume, play, playing]);
  useEffect12(() => {
    const { current } = container;
    if (!current) {
      return;
    }
    const onFullscreenChange = () => {
      const newValue = document.fullscreenElement === current || document.webkitFullscreenElement === current;
      setIsFullscreen(newValue);
    };
    document.addEventListener("fullscreenchange", onFullscreenChange);
    document.addEventListener("webkitfullscreenchange", onFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", onFullscreenChange);
      document.removeEventListener("webkitfullscreenchange", onFullscreenChange);
    };
  }, []);
  const toggle = useCallback10((e) => {
    if (player.isPlaying()) {
      player.pause();
    } else {
      play(e);
    }
  }, [play, player]);
  const requestFullscreen = useCallback10(() => {
    if (!allowFullscreen) {
      throw new Error("allowFullscreen is false");
    }
    if (!supportsFullScreen) {
      throw new Error("Browser doesnt support fullscreen");
    }
    if (!container.current) {
      throw new Error("No player ref found");
    }
    if (container.current.webkitRequestFullScreen) {
      container.current.webkitRequestFullScreen();
    } else {
      container.current.requestFullscreen();
    }
  }, [allowFullscreen, supportsFullScreen]);
  const exitFullscreen = useCallback10(() => {
    if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else {
      document.exitFullscreen();
    }
  }, []);
  useEffect12(() => {
    const { current } = container;
    if (!current) {
      return;
    }
    const fullscreenChange = () => {
      const element = document.webkitFullscreenElement ?? document.fullscreenElement;
      if (element && element === container.current) {
        player.emitter.dispatchFullscreenChange({
          isFullscreen: true
        });
      } else {
        player.emitter.dispatchFullscreenChange({
          isFullscreen: false
        });
      }
    };
    current.addEventListener("webkitfullscreenchange", fullscreenChange);
    current.addEventListener("fullscreenchange", fullscreenChange);
    return () => {
      current.removeEventListener("webkitfullscreenchange", fullscreenChange);
      current.removeEventListener("fullscreenchange", fullscreenChange);
    };
  }, [player.emitter]);
  const durationInFrames = config?.durationInFrames ?? 1;
  const layout = useMemo12(() => {
    if (!config || !canvasSize) {
      return null;
    }
    return calculateCanvasTransformation({
      canvasSize,
      compositionHeight: config.height,
      compositionWidth: config.width,
      previewSize: "auto"
    });
  }, [canvasSize, config]);
  const scale = layout?.scale ?? 1;
  const canvasContent = useMemo12(() => ({ rootRef: canvasContentRef, scale }), [scale]);
  const initialScaleIgnored = useRef10(false);
  useEffect12(() => {
    if (!initialScaleIgnored.current) {
      initialScaleIgnored.current = true;
      return;
    }
    player.emitter.dispatchScaleChange(scale);
  }, [player.emitter, scale]);
  const [showBufferIndicator, setShowBufferState] = useState10(false);
  useEffect12(() => {
    let timeout = null;
    let stopped = false;
    const onBuffer = () => {
      stopped = false;
      requestAnimationFrame(() => {
        if (bufferStateDelayInMilliseconds === 0) {
          setShowBufferState(true);
        } else {
          timeout = setTimeout(() => {
            if (!stopped) {
              setShowBufferState(true);
            }
          }, bufferStateDelayInMilliseconds);
        }
      });
    };
    const onResume = () => {
      requestAnimationFrame(() => {
        stopped = true;
        setShowBufferState(false);
        if (timeout) {
          clearTimeout(timeout);
        }
      });
    };
    player.emitter.addEventListener("waiting", onBuffer);
    player.emitter.addEventListener("resume", onResume);
    return () => {
      player.emitter.removeEventListener("waiting", onBuffer);
      player.emitter.removeEventListener("resume", onResume);
      setShowBufferState(false);
      if (timeout) {
        clearTimeout(timeout);
      }
      stopped = true;
    };
  }, [bufferStateDelayInMilliseconds, player.emitter]);
  useImperativeHandle(ref, () => {
    const methods = {
      play,
      pause: () => {
        setHasPausedToResume(false);
        player.pause();
      },
      toggle,
      getContainerNode: () => container.current,
      getCurrentFrame: player.getCurrentFrame,
      isPlaying: player.isPlaying,
      seekTo: (f) => {
        const lastFrame = durationInFrames - 1;
        const frameToSeekTo = Math.max(0, Math.min(lastFrame, f));
        if (player.isPlaying()) {
          const pauseToResume = frameToSeekTo !== lastFrame || loop;
          setHasPausedToResume(pauseToResume);
          player.pause();
        }
        if (frameToSeekTo === lastFrame && !loop) {
          player.emitter.dispatchEnded();
        }
        player.seek(frameToSeekTo);
      },
      isFullscreen: () => {
        const { current } = container;
        if (!current) {
          return false;
        }
        return document.fullscreenElement === current || document.webkitFullscreenElement === current;
      },
      requestFullscreen,
      exitFullscreen,
      getVolume: () => {
        if (playerMuted) {
          return 0;
        }
        return mediaVolume;
      },
      setVolume: (vol) => {
        if (typeof vol !== "number") {
          throw new TypeError(`setVolume() takes a number, got value of type ${typeof vol}`);
        }
        if (isNaN(vol)) {
          throw new TypeError(`setVolume() got a number that is NaN. Volume must be between 0 and 1.`);
        }
        if (vol < 0 || vol > 1) {
          throw new TypeError(`setVolume() got a number that is out of range. Must be between 0 and 1, got ${vol}`);
        }
        setMediaVolume(vol);
      },
      isMuted: () => isMuted,
      mute: () => {
        setPlayerMuted(true);
      },
      unmute: () => {
        setPlayerMuted(false);
      },
      getScale: () => scale,
      pauseAndReturnToPlayStart: () => {
        player.pauseAndReturnToPlayStart();
      }
    };
    return Object.assign(player.emitter, methods);
  }, [
    durationInFrames,
    exitFullscreen,
    loop,
    playerMuted,
    isMuted,
    mediaVolume,
    player,
    play,
    requestFullscreen,
    setPlayerMuted,
    setMediaVolume,
    toggle,
    scale
  ]);
  const VideoComponent = video ? video.component : null;
  const outerStyle = useMemo12(() => {
    return calculateOuterStyle({
      canvasSize,
      config,
      style,
      overflowVisible,
      layout
    });
  }, [canvasSize, config, layout, overflowVisible, style]);
  const outer = useMemo12(() => {
    return calculateOuter({ config, layout, scale, overflowVisible });
  }, [config, layout, overflowVisible, scale]);
  const containerStyle = useMemo12(() => {
    return calculateContainerStyle({
      config,
      layout,
      scale,
      overflowVisible
    });
  }, [config, layout, overflowVisible, scale]);
  const playerPause = player.pause;
  const playerDispatchError = player.emitter.dispatchError;
  const onError = useCallback10((error) => {
    playerPause();
    playerDispatchError(error);
  }, [playerDispatchError, playerPause]);
  const onFullscreenButtonClick = useCallback10((e) => {
    e.stopPropagation();
    requestFullscreen();
  }, [requestFullscreen]);
  const onExitFullscreenButtonClick = useCallback10((e) => {
    e.stopPropagation();
    exitFullscreen();
  }, [exitFullscreen]);
  const onSingleClick = useCallback10((e) => {
    const rightClick = e instanceof MouseEvent ? e.button === 2 : e.nativeEvent.button;
    if (rightClick) {
      return;
    }
    toggle(e);
  }, [toggle]);
  const onSeekStart = useCallback10(() => {
    setSeeking(true);
  }, []);
  const onSeekEnd = useCallback10(() => {
    setSeeking(false);
  }, []);
  const onDoubleClick = useCallback10(() => {
    if (isFullscreen) {
      exitFullscreen();
    } else {
      requestFullscreen();
    }
  }, [exitFullscreen, isFullscreen, requestFullscreen]);
  const { handlePointerDown, handleDoubleClick } = useClickPreventionOnDoubleClick(onSingleClick, onDoubleClick, doubleClickToFullscreen && allowFullscreen && supportsFullScreen);
  useEffect12(() => {
    if (shouldAutoplay) {
      setHasPlayed(true);
      player.playAsAutoPlay();
      setShouldAutoPlay(false);
    }
  }, [player, shouldAutoplay]);
  const loadingMarkup = useMemo12(() => {
    return renderLoading ? renderLoading({
      height: outerStyle.height,
      width: outerStyle.width,
      isBuffering: showBufferIndicator
    }) : null;
  }, [outerStyle.height, outerStyle.width, renderLoading, showBufferIndicator]);
  const currentScale = useMemo12(() => {
    return {
      type: "scale",
      scale
    };
  }, [scale]);
  if (!config) {
    return null;
  }
  const poster = renderPoster ? renderPoster({
    height: posterFillMode === "player-size" ? outerStyle.height : config.height,
    width: posterFillMode === "player-size" ? outerStyle.width : config.width,
    isBuffering: showBufferIndicator
  }) : null;
  if (poster === undefined) {
    throw new TypeError("renderPoster() must return a React element, but undefined was returned");
  }
  const shouldShowPoster = poster && [
    showPosterWhenPaused && !playing && !seeking,
    showPosterWhenEnded && frame === durationInFrames - 1 && !playing,
    showPosterWhenUnplayed && !hasPlayed && !playing,
    showPosterWhenBuffering && showBufferIndicator && playing,
    showPosterWhenBufferingAndPaused && showBufferIndicator && !playing
  ].some(Boolean);
  const { left, top, width, height, ...outerWithoutScale } = outer;
  const content = /* @__PURE__ */ jsxs9(Fragment3, {
    children: [
      /* @__PURE__ */ jsxs9("div", {
        style: outer,
        onPointerDown: clickToPlay ? handlePointerDown : undefined,
        onDoubleClick: doubleClickToFullscreen ? handleDoubleClick : undefined,
        children: [
          /* @__PURE__ */ jsxs9("div", {
            ref: canvasContentRef,
            style: containerStyle,
            className: playerCssClassname(overrideInternalClassName),
            children: [
              VideoComponent ? /* @__PURE__ */ jsx12(ErrorBoundary, {
                onError,
                errorFallback,
                children: /* @__PURE__ */ jsx12(Internals11.CurrentScaleContext.Provider, {
                  value: currentScale,
                  children: /* @__PURE__ */ jsx12(CanvasOverlayContext.Provider, {
                    value: null,
                    children: /* @__PURE__ */ jsx12(VideoComponent, {
                      ...video?.props ?? {},
                      ...inputProps ?? {}
                    })
                  })
                })
              }) : null,
              shouldShowPoster && posterFillMode === "composition-size" ? /* @__PURE__ */ jsx12("div", {
                style: {
                  ...outerWithoutScale,
                  width: config.width,
                  height: config.height
                },
                onPointerDown: clickToPlay ? handlePointerDown : undefined,
                onDoubleClick: doubleClickToFullscreen ? handleDoubleClick : undefined,
                children: poster
              }) : null
            ]
          }),
          /* @__PURE__ */ jsx12(RenderWarningIfBlacklist, {}),
          /* @__PURE__ */ jsx12(CanvasContentContext.Provider, {
            value: canvasContent,
            children: canvasOverlay
          })
        ]
      }),
      shouldShowPoster && posterFillMode === "player-size" ? /* @__PURE__ */ jsx12("div", {
        style: outer,
        onPointerDown: clickToPlay ? handlePointerDown : undefined,
        onDoubleClick: doubleClickToFullscreen ? handleDoubleClick : undefined,
        children: poster
      }) : null,
      controls ? /* @__PURE__ */ jsx12(Controls, {
        fps: config.fps,
        playing,
        toggle,
        durationInFrames: config.durationInFrames,
        containerRef: container,
        onFullscreenButtonClick,
        isFullscreen,
        allowFullscreen,
        showVolumeControls,
        onExitFullscreenButtonClick,
        spaceKeyToPlayOrPause,
        onSeekEnd,
        onSeekStart,
        inFrame,
        outFrame,
        initiallyShowControls,
        canvasSize,
        renderFullscreenButton,
        renderPlayPauseButton,
        alwaysShowControls,
        showPlaybackRateControl,
        buffering: showBufferIndicator,
        hideControlsWhenPointerDoesntMove,
        onDoubleClick: doubleClickToFullscreen ? handleDoubleClick : undefined,
        onPointerDown: clickToPlay ? handlePointerDown : undefined,
        renderMuteButton,
        renderVolumeSlider,
        renderCustomControls
      }) : null
    ]
  });
  if (noSuspense || IS_NODE && !doesReactVersionSupportSuspense) {
    return /* @__PURE__ */ jsx12("div", {
      ref: container,
      style: outerStyle,
      className,
      children: content
    });
  }
  return /* @__PURE__ */ jsx12("div", {
    ref: container,
    style: outerStyle,
    className,
    children: /* @__PURE__ */ jsx12(Suspense, {
      fallback: loadingMarkup,
      children: content
    })
  });
};
var PlayerUI_default = forwardRef(PlayerUI);

// src/SharedPlayerContext.tsx
import { useCallback as useCallback11, useMemo as useMemo13, useRef as useRef11, useState as useState11 } from "react";
import { Internals as Internals13 } from "remotion";

// src/volume-persistence.ts
import { Internals as Internals12 } from "remotion";
var DEFAULT_VOLUME_PERSISTENCE_KEY = "remotion.volumePreference";
var persistVolume = (volume, logLevel, volumePersistenceKey) => {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.localStorage.setItem(volumePersistenceKey ?? DEFAULT_VOLUME_PERSISTENCE_KEY, String(volume));
  } catch (e) {
    Internals12.Log.error({ logLevel, tag: null }, "Could not persist volume", e);
  }
};
var getPreferredVolume = (volumePersistenceKey) => {
  if (typeof window === "undefined") {
    return 1;
  }
  try {
    const val = window.localStorage.getItem(volumePersistenceKey ?? DEFAULT_VOLUME_PERSISTENCE_KEY);
    return val ? Number(val) : 1;
  } catch {
    return 1;
  }
};

// src/SharedPlayerContext.tsx
import { jsx as jsx13 } from "react/jsx-runtime";
var PLAYER_COMP_ID = "player-comp";
var SharedPlayerContexts = ({
  children,
  timelineContext,
  playbackRateContext,
  preservePitch,
  fps,
  compositionHeight,
  compositionWidth,
  durationInFrames,
  component,
  numberOfSharedAudioTags,
  initiallyMuted,
  logLevel,
  audioLatencyHint,
  preferredEffectBackend,
  sampleRate,
  volumePersistenceKey,
  initialVolume,
  inputProps,
  audioEnabled,
  _experimentalKeepAudioContextAlive
}) => {
  const persistVolumeToStorage = initialVolume === undefined;
  const compositionManagerContext = useMemo13(() => {
    const context = {
      compositions: [
        {
          component,
          durationInFrames,
          height: compositionHeight,
          width: compositionWidth,
          fps,
          id: PLAYER_COMP_ID,
          order: null,
          folderName: null,
          parentFolderName: null,
          schema: null,
          calculateMetadata: null,
          stack: null
        }
      ],
      folders: [],
      currentAssetMetadata: null,
      currentCompositionMetadata: {
        defaultCodec: null,
        defaultOutName: null,
        defaultPixelFormat: null,
        defaultProResProfile: null,
        defaultSampleRate: null,
        defaultVideoImageFormat: null,
        durationInFrames,
        fps,
        height: compositionHeight,
        width: compositionWidth,
        props: inputProps
      },
      canvasContent: { type: "composition", compositionId: "player-comp" }
    };
    return context;
  }, [
    component,
    durationInFrames,
    compositionHeight,
    compositionWidth,
    fps,
    inputProps
  ]);
  const [playerMuted, setPlayerMuted] = useState11(() => initiallyMuted);
  const [mediaVolume, setMediaVolume] = useState11(() => persistVolumeToStorage ? getPreferredVolume(volumePersistenceKey ?? null) : initialVolume);
  const mediaVolumeContextValue = useMemo13(() => {
    return {
      playerMuted,
      mediaVolume
    };
  }, [playerMuted, mediaVolume]);
  const audioContextWasCreated = useRef11(false);
  const shouldCreateAudioContext = audioContextWasCreated.current || audioEnabled && !playerMuted && mediaVolume > 0;
  audioContextWasCreated.current = shouldCreateAudioContext;
  const setMediaVolumeAndPersist = useCallback11((vol) => {
    setMediaVolume(vol);
    if (persistVolumeToStorage) {
      persistVolume(vol, logLevel, volumePersistenceKey ?? null);
    }
  }, [persistVolumeToStorage, logLevel, volumePersistenceKey]);
  const setMediaVolumeContextValue = useMemo13(() => {
    return {
      setPlayerMuted,
      setMediaVolume: setMediaVolumeAndPersist
    };
  }, [setMediaVolumeAndPersist]);
  const logLevelContext = useMemo13(() => {
    return {
      logLevel,
      mountTime: Date.now()
    };
  }, [logLevel]);
  const env = useMemo13(() => {
    return {
      isPlayer: true,
      isRendering: false,
      isStudio: false,
      isClientSideRendering: false,
      isReadOnlyStudio: false
    };
  }, []);
  return /* @__PURE__ */ jsx13(Internals13.RemotionEnvironmentContext.Provider, {
    value: env,
    children: /* @__PURE__ */ jsx13(Internals13.LogLevelContext.Provider, {
      value: logLevelContext,
      children: /* @__PURE__ */ jsx13(Internals13.CanUseRemotionHooksProvider, {
        children: /* @__PURE__ */ jsx13(Internals13.AbsoluteTimeContext.Provider, {
          value: timelineContext,
          children: /* @__PURE__ */ jsx13(Internals13.PlaybackRateContext.Provider, {
            value: playbackRateContext,
            children: /* @__PURE__ */ jsx13(Internals13.PlaybackPitchContext.Provider, {
              value: preservePitch,
              children: /* @__PURE__ */ jsx13(Internals13.TimelineContext.Provider, {
                value: timelineContext,
                children: /* @__PURE__ */ jsx13(Internals13.CompositionManager.Provider, {
                  value: compositionManagerContext,
                  children: /* @__PURE__ */ jsx13(Internals13.VideoProvider, {
                    children: /* @__PURE__ */ jsx13(Internals13.PrefetchProvider, {
                      children: /* @__PURE__ */ jsx13(Internals13.DurationsContextProvider, {
                        children: /* @__PURE__ */ jsx13(Internals13.MediaVolumeContext.Provider, {
                          value: mediaVolumeContextValue,
                          children: /* @__PURE__ */ jsx13(Internals13.SetMediaVolumeContext.Provider, {
                            value: setMediaVolumeContextValue,
                            children: /* @__PURE__ */ jsx13(Internals13.BufferingProvider, {
                              children: /* @__PURE__ */ jsx13(Internals13.SharedAudioContextProvider, {
                                audioLatencyHint,
                                audioEnabled: shouldCreateAudioContext,
                                previewSampleRate: sampleRate,
                                _experimentalKeepAudioContextAlive,
                                children: /* @__PURE__ */ jsx13(Internals13.SharedAudioTagsContextProvider, {
                                  numberOfAudioTags: numberOfSharedAudioTags,
                                  children: /* @__PURE__ */ jsx13(Internals13.PreferredEffectBackendContext.Provider, {
                                    value: Internals13.validatePreferredEffectBackend(preferredEffectBackend),
                                    children
                                  })
                                })
                              })
                            })
                          })
                        })
                      })
                    })
                  })
                })
              })
            })
          })
        })
      })
    })
  });
};

// src/use-remotion-license-acknowledge.ts
import { Internals as Internals14 } from "remotion";
var warningShown = false;
var acknowledgeRemotionLicenseMessage = (acknowledge, logLevel) => {
  if (acknowledge) {
    return;
  }
  if (warningShown) {
    return;
  }
  warningShown = true;
  Internals14.Log.warn({ logLevel, tag: null }, "Note: Some companies are required to obtain a license to use Remotion. See: https://remotion.dev/license\nPass the `acknowledgeRemotionLicense` prop to `<Player />` function to make this message disappear.");
};

// src/utils/validate-in-out-frame.ts
var validateSingleFrame = (frame, variableName) => {
  if (typeof frame === "undefined" || frame === null) {
    return frame ?? null;
  }
  if (typeof frame !== "number") {
    throw new TypeError(`"${variableName}" must be a number, but is ${JSON.stringify(frame)}`);
  }
  if (Number.isNaN(frame)) {
    throw new TypeError(`"${variableName}" must not be NaN, but is ${JSON.stringify(frame)}`);
  }
  if (!Number.isFinite(frame)) {
    throw new TypeError(`"${variableName}" must be finite, but is ${JSON.stringify(frame)}`);
  }
  if (frame % 1 !== 0) {
    throw new TypeError(`"${variableName}" must be an integer, but is ${JSON.stringify(frame)}`);
  }
  return frame;
};
var validateInOutFrames = ({
  inFrame,
  durationInFrames,
  outFrame
}) => {
  const validatedInFrame = validateSingleFrame(inFrame, "inFrame");
  const validatedOutFrame = validateSingleFrame(outFrame, "outFrame");
  if (validatedInFrame === null && validatedOutFrame === null) {
    return;
  }
  if (validatedInFrame !== null && validatedInFrame > durationInFrames - 1) {
    throw new Error("inFrame must be less than (durationInFrames - 1), but is " + validatedInFrame);
  }
  if (validatedOutFrame !== null && validatedOutFrame > durationInFrames - 1) {
    throw new Error("outFrame must be less than (durationInFrames - 1), but is " + validatedOutFrame);
  }
  if (validatedInFrame !== null && validatedInFrame < 0) {
    throw new Error("inFrame must be greater than 0, but is " + validatedInFrame);
  }
  if (validatedOutFrame !== null && validatedOutFrame <= 0) {
    throw new Error(`outFrame must be greater than 0, but is ${validatedOutFrame}. If you want to render a single frame, use <Thumbnail /> instead.`);
  }
  if (validatedOutFrame !== null && validatedInFrame !== null && validatedOutFrame <= validatedInFrame) {
    throw new Error("outFrame must be greater than inFrame, but is " + validatedOutFrame + " <= " + validatedInFrame);
  }
};

// src/utils/validate-initial-frame.ts
var validateInitialFrame = ({
  initialFrame,
  durationInFrames
}) => {
  if (typeof durationInFrames !== "number") {
    throw new Error(`\`durationInFrames\` must be a number, but is ${JSON.stringify(durationInFrames)}`);
  }
  if (typeof initialFrame === "undefined") {
    return;
  }
  if (typeof initialFrame !== "number") {
    throw new Error(`\`initialFrame\` must be a number, but is ${JSON.stringify(initialFrame)}`);
  }
  if (Number.isNaN(initialFrame)) {
    throw new Error(`\`initialFrame\` must be a number, but is NaN`);
  }
  if (!Number.isFinite(initialFrame)) {
    throw new Error(`\`initialFrame\` must be a number, but is Infinity`);
  }
  if (initialFrame % 1 !== 0) {
    throw new Error(`\`initialFrame\` must be an integer, but is ${JSON.stringify(initialFrame)}`);
  }
  if (initialFrame > durationInFrames - 1) {
    throw new Error(`\`initialFrame\` must be less or equal than \`durationInFrames - 1\`, but is ${JSON.stringify(initialFrame)}`);
  }
};

// src/utils/validate-playbackrate.ts
var validatePlaybackRate = (playbackRate) => {
  if (playbackRate === undefined) {
    return;
  }
  if (playbackRate > 10) {
    throw new Error(`The highest possible playback rate is 10. You passed: ${playbackRate}`);
  }
  if (playbackRate < -10) {
    throw new Error(`The lowest possible playback rate is -10. You passed: ${playbackRate}`);
  }
  if (playbackRate === 0) {
    throw new Error(`A playback rate of 0 is not supported.`);
  }
};

// src/validate.ts
import { NoReactInternals } from "remotion/no-react";
var validateFps = NoReactInternals.validateFps;
var validateDimension = NoReactInternals.validateDimension;
var validateDurationInFrames = NoReactInternals.validateDurationInFrames;
var validateDefaultAndInputProps = NoReactInternals.validateDefaultAndInputProps;

// src/Player.tsx
import { jsx as jsx14, jsxs as jsxs10 } from "react/jsx-runtime";
var componentOrNullIfLazy = (props) => {
  if ("component" in props) {
    return props.component;
  }
  return null;
};
var TimelineSequenceObserverComponent = ({ onTimelineSequenceChange }) => {
  const registry = React13.useContext(Internals15.SequenceRegistryContext);
  useLayoutEffect3(() => {
    if (registry === null) {
      throw new Error("Timeline sequence observer requires a sequence registry");
    }
    const publish = () => onTimelineSequenceChange(registry.getSnapshot());
    const unsubscribe = registry.subscribe(publish);
    publish();
    return unsubscribe;
  }, [onTimelineSequenceChange, registry]);
  return null;
};
var PlayerFn = ({
  durationInFrames,
  compositionHeight,
  compositionWidth,
  fps,
  inputProps,
  style,
  controls = false,
  loop = false,
  autoPlay = false,
  showVolumeControls = true,
  allowFullscreen = true,
  clickToPlay,
  doubleClickToFullscreen = false,
  spaceKeyToPlayOrPause = true,
  moveToBeginningWhenEnded = true,
  numberOfSharedAudioTags = NoReactInternals2.ENABLE_V5_BREAKING_CHANGES ? 0 : 5,
  errorFallback = () => "⚠️",
  playbackRate = 1,
  preservePitch = false,
  renderLoading,
  className,
  showPosterWhenUnplayed,
  showPosterWhenEnded,
  showPosterWhenPaused,
  showPosterWhenBuffering,
  showPosterWhenBufferingAndPaused,
  initialFrame,
  renderPoster,
  inFrame,
  outFrame,
  initiallyShowControls,
  renderFullscreenButton,
  renderPlayPauseButton,
  renderVolumeSlider,
  renderCustomControls,
  alwaysShowControls = false,
  initiallyMuted = false,
  showPlaybackRateControl = false,
  posterFillMode = "player-size",
  bufferStateDelayInMilliseconds,
  defaultPremountInSeconds = NoReactInternals2.DEFAULT_PREMOUNT_IN_SECONDS,
  hideControlsWhenPointerDoesntMove = true,
  overflowVisible = false,
  renderMuteButton,
  browserMediaControlsBehavior: passedBrowserMediaControlsBehavior,
  overrideInternalClassName,
  logLevel = "info",
  noSuspense,
  acknowledgeRemotionLicense,
  audioLatencyHint = "playback",
  preferredEffectBackend = "auto",
  sampleRate = 48000,
  volumePersistenceKey,
  initialVolume,
  _experimentalKeepAudioContextAlive = false,
  ...componentProps
}, ref) => {
  NoReactInternals2.validateDefaultPremountInSeconds(defaultPremountInSeconds);
  if (typeof window !== "undefined") {
    window.remotion_isPlayer = true;
  }
  const onTimelineSequenceChange = React13.useContext(TimelineSequenceObserverContext);
  if (componentProps.defaultProps !== undefined) {
    throw new Error("The <Player /> component does not accept `defaultProps`, but some were passed. Use `inputProps` instead.");
  }
  const componentForValidation = componentOrNullIfLazy(componentProps);
  if (componentForValidation?.type === Composition) {
    throw new TypeError(`'component' should not be an instance of <Composition/>. Pass the React component directly, and set the duration, fps and dimensions as separate props. See https://www.remotion.dev/docs/player/examples for an example.`);
  }
  if (componentForValidation === Composition) {
    throw new TypeError(`'component' must not be the 'Composition' component. Pass your own React component directly, and set the duration, fps and dimensions as separate props. See https://www.remotion.dev/docs/player/examples for an example.`);
  }
  useState12(() => acknowledgeRemotionLicenseMessage(Boolean(acknowledgeRemotionLicense), logLevel));
  const component = Internals15.useLazyComponent({
    compProps: componentProps,
    componentName: "Player",
    noSuspense: Boolean(noSuspense)
  });
  validateInitialFrame({ initialFrame, durationInFrames });
  const [frame, setFrame] = useState12(() => ({
    [PLAYER_COMP_ID]: initialFrame ?? 0
  }));
  const seek = Internals15.useTimelineSeek(setFrame);
  const frameRef = useRef12(frame);
  frameRef.current = frame;
  const rootRef = useRef12(null);
  const audioAndVideoTags = useRef12([]);
  const playingStore = useMemo14(() => Internals15.createRuntimeValueStore({ playing: false }), []);
  const bufferingStore = useMemo14(() => Internals15.createRuntimeValueStore({ buffering: false }), []);
  const readIsPlaying = useCallback12(() => playingStore.store.getSnapshot().playing, [playingStore]);
  const readIsBuffering = useCallback12(() => bufferingStore.store.getSnapshot().buffering, [bufferingStore]);
  const [currentPlaybackRate, setCurrentPlaybackRate] = useState12(playbackRate);
  if (typeof compositionHeight !== "number") {
    throw new TypeError(`'compositionHeight' must be a number but got '${typeof compositionHeight}' instead`);
  }
  if (typeof compositionWidth !== "number") {
    throw new TypeError(`'compositionWidth' must be a number but got '${typeof compositionWidth}' instead`);
  }
  validateDimension(compositionHeight, "compositionHeight", "of the <Player /> component");
  validateDimension(compositionWidth, "compositionWidth", "of the <Player /> component");
  validateDurationInFrames(durationInFrames, {
    component: "of the <Player/> component",
    allowFloats: false
  });
  validateFps(fps, "as a prop of the <Player/> component", false);
  validateDefaultAndInputProps(inputProps, "inputProps", null);
  validateInOutFrames({
    durationInFrames,
    inFrame,
    outFrame
  });
  if (typeof controls !== "boolean" && typeof controls !== "undefined") {
    throw new TypeError(`'controls' must be a boolean or undefined but got '${typeof controls}' instead`);
  }
  if (typeof preservePitch !== "boolean") {
    throw new TypeError(`'preservePitch' must be a boolean but got '${typeof preservePitch}' instead`);
  }
  if (typeof autoPlay !== "boolean" && typeof autoPlay !== "undefined") {
    throw new TypeError(`'autoPlay' must be a boolean or undefined but got '${typeof autoPlay}' instead`);
  }
  if (typeof loop !== "boolean" && typeof loop !== "undefined") {
    throw new TypeError(`'loop' must be a boolean or undefined but got '${typeof loop}' instead`);
  }
  if (typeof doubleClickToFullscreen !== "boolean" && typeof doubleClickToFullscreen !== "undefined") {
    throw new TypeError(`'doubleClickToFullscreen' must be a boolean or undefined but got '${typeof doubleClickToFullscreen}' instead`);
  }
  if (typeof showVolumeControls !== "boolean" && typeof showVolumeControls !== "undefined") {
    throw new TypeError(`'showVolumeControls' must be a boolean or undefined but got '${typeof showVolumeControls}' instead`);
  }
  if (typeof allowFullscreen !== "boolean" && typeof allowFullscreen !== "undefined") {
    throw new TypeError(`'allowFullscreen' must be a boolean or undefined but got '${typeof allowFullscreen}' instead`);
  }
  if (typeof clickToPlay !== "boolean" && typeof clickToPlay !== "undefined") {
    throw new TypeError(`'clickToPlay' must be a boolean or undefined but got '${typeof clickToPlay}' instead`);
  }
  if (typeof spaceKeyToPlayOrPause !== "boolean" && typeof spaceKeyToPlayOrPause !== "undefined") {
    throw new TypeError(`'spaceKeyToPlayOrPause' must be a boolean or undefined but got '${typeof spaceKeyToPlayOrPause}' instead`);
  }
  if (typeof sampleRate !== "number" || !Number.isFinite(sampleRate) || Number.isNaN(sampleRate) || sampleRate <= 0 || sampleRate % 1 !== 0) {
    throw new TypeError(`'sampleRate' must be a positive integer but got '${sampleRate}' instead`);
  }
  if (typeof initialVolume !== "undefined" && typeof initialVolume !== "number") {
    throw new TypeError(`'initialVolume' must be a number or undefined but got '${typeof initialVolume}' instead`);
  }
  if (typeof initialVolume === "number" && (!Number.isFinite(initialVolume) || Number.isNaN(initialVolume) || initialVolume < 0 || initialVolume > 1)) {
    throw new TypeError(`'initialVolume' must be between 0 and 1 but got '${initialVolume}' instead`);
  }
  if (typeof numberOfSharedAudioTags !== "number" || numberOfSharedAudioTags % 1 !== 0 || !Number.isFinite(numberOfSharedAudioTags) || Number.isNaN(numberOfSharedAudioTags) || numberOfSharedAudioTags < 0) {
    throw new TypeError(`'numberOfSharedAudioTags' must be an integer but got '${numberOfSharedAudioTags}' instead`);
  }
  validatePlaybackRate(currentPlaybackRate);
  useEffect13(() => {
    setCurrentPlaybackRate(playbackRate);
  }, [playbackRate]);
  useImperativeHandle2(ref, () => rootRef.current, []);
  useState12(() => {
    Internals15.playbackLogging({
      logLevel,
      message: `[player] Mounting <Player>. User agent = ${typeof navigator === "undefined" ? "server" : navigator.userAgent}`,
      tag: "player",
      mountTime: Date.now()
    });
  });
  const timelineContextValue = useMemo14(() => {
    return {
      frame,
      isPlaying: readIsPlaying,
      isInsideFreeze: false,
      audioAndVideoTags
    };
  }, [frame, readIsPlaying]);
  const playbackRateContextValue = useMemo14(() => {
    return {
      playbackRate: currentPlaybackRate,
      setPlaybackRate: setCurrentPlaybackRate
    };
  }, [currentPlaybackRate]);
  const setTimelineContextValue = useMemo14(() => {
    return {
      setFrameWithoutSeek: setFrame,
      seek,
      setPlaying: (updater) => {
        const current = playingStore.store.getSnapshot().playing;
        const next = typeof updater === "function" ? updater(current) : updater;
        if (current !== next) {
          playingStore.setSnapshot({ playing: next });
        }
      },
      setBuffering: (buffering) => {
        if (readIsBuffering() !== buffering) {
          bufferingStore.setSnapshot({ buffering });
        }
      },
      subscribePlaying: playingStore.store.subscribe,
      subscribeBuffering: bufferingStore.store.subscribe,
      isPlaying: readIsPlaying,
      isBuffering: readIsBuffering,
      frameRef,
      audioAndVideoTags
    };
  }, [
    bufferingStore,
    seek,
    setFrame,
    frameRef,
    playingStore,
    readIsBuffering,
    readIsPlaying
  ]);
  if (typeof window !== "undefined") {
    useLayoutEffect3(() => {
      Internals15.CSSUtils.injectCSS(Internals15.CSSUtils.makeDefaultPreviewCSS(`.${playerCssClassname(overrideInternalClassName)}`, "#fff"));
    }, [overrideInternalClassName]);
  }
  const actualInputProps = useMemo14(() => inputProps ?? {}, [inputProps]);
  const browserMediaControlsBehavior = useMemo14(() => {
    return passedBrowserMediaControlsBehavior ?? {
      mode: "prevent-media-session"
    };
  }, [passedBrowserMediaControlsBehavior]);
  const player = /* @__PURE__ */ jsx14(Internals15.IsPlayerContextProvider, {
    children: /* @__PURE__ */ jsx14(Internals15.SetTimelineContext.Provider, {
      value: setTimelineContextValue,
      children: /* @__PURE__ */ jsx14(SharedPlayerContexts, {
        timelineContext: timelineContextValue,
        playbackRateContext: playbackRateContextValue,
        preservePitch,
        component,
        compositionHeight,
        compositionWidth,
        durationInFrames,
        fps,
        numberOfSharedAudioTags,
        initiallyMuted,
        logLevel,
        audioLatencyHint,
        preferredEffectBackend,
        sampleRate,
        _experimentalKeepAudioContextAlive,
        volumePersistenceKey,
        initialVolume,
        inputProps: actualInputProps,
        audioEnabled: true,
        children: /* @__PURE__ */ jsx14(PlayerEmitterProvider, {
          currentPlaybackRate,
          children: /* @__PURE__ */ jsx14(PlayerUI_default, {
            ref: rootRef,
            posterFillMode,
            renderLoading,
            autoPlay: Boolean(autoPlay),
            loop: Boolean(loop),
            controls: Boolean(controls),
            errorFallback,
            style,
            inputProps: actualInputProps,
            allowFullscreen: Boolean(allowFullscreen),
            moveToBeginningWhenEnded: Boolean(moveToBeginningWhenEnded),
            clickToPlay: typeof clickToPlay === "boolean" ? clickToPlay : Boolean(controls),
            showVolumeControls: Boolean(showVolumeControls),
            doubleClickToFullscreen: Boolean(doubleClickToFullscreen),
            spaceKeyToPlayOrPause: Boolean(spaceKeyToPlayOrPause),
            playbackRate: currentPlaybackRate,
            className: className ?? undefined,
            showPosterWhenUnplayed: Boolean(showPosterWhenUnplayed),
            showPosterWhenEnded: Boolean(showPosterWhenEnded),
            showPosterWhenPaused: Boolean(showPosterWhenPaused),
            showPosterWhenBuffering: Boolean(showPosterWhenBuffering),
            showPosterWhenBufferingAndPaused: Boolean(showPosterWhenBufferingAndPaused),
            renderPoster,
            inFrame: inFrame ?? null,
            outFrame: outFrame ?? null,
            initiallyShowControls: initiallyShowControls ?? true,
            renderFullscreen: renderFullscreenButton ?? null,
            renderPlayPauseButton: renderPlayPauseButton ?? null,
            renderMuteButton: renderMuteButton ?? null,
            renderVolumeSlider: renderVolumeSlider ?? null,
            renderCustomControls: renderCustomControls ?? null,
            alwaysShowControls,
            showPlaybackRateControl,
            bufferStateDelayInMilliseconds: bufferStateDelayInMilliseconds ?? 300,
            hideControlsWhenPointerDoesntMove,
            overflowVisible,
            browserMediaControlsBehavior,
            overrideInternalClassName: overrideInternalClassName ?? undefined,
            noSuspense: Boolean(noSuspense)
          })
        })
      })
    })
  });
  return /* @__PURE__ */ jsx14(Internals15.DefaultPremountContext.Provider, {
    value: defaultPremountInSeconds,
    children: onTimelineSequenceChange ? /* @__PURE__ */ jsx14(Internals15.SequenceRegistrationContext.Provider, {
      value: true,
      children: /* @__PURE__ */ jsxs10(Internals15.SequenceManagerProvider, {
        children: [
          /* @__PURE__ */ jsx14(TimelineSequenceObserverComponent, {
            onTimelineSequenceChange
          }),
          player
        ]
      })
    }) : player
  });
};
var forward = forwardRef2;
var Player = forward(PlayerFn);
// src/Thumbnail.tsx
import {
  forwardRef as forwardRef4,
  useImperativeHandle as useImperativeHandle4,
  useLayoutEffect as useLayoutEffect4,
  useMemo as useMemo17,
  useRef as useRef14,
  useState as useState13
} from "react";
import { Internals as Internals17 } from "remotion";

// src/ThumbnailUI.tsx
import React14, {
  forwardRef as forwardRef3,
  Suspense as Suspense2,
  useCallback as useCallback13,
  useImperativeHandle as useImperativeHandle3,
  useMemo as useMemo16,
  useRef as useRef13
} from "react";
import { Internals as Internals16 } from "remotion";

// src/use-thumbnail.ts
import { useContext as useContext5, useMemo as useMemo15 } from "react";
var useThumbnail = () => {
  const emitter = useContext5(ThumbnailEmitterContext);
  if (!emitter) {
    throw new TypeError("Expected Player event emitter context");
  }
  const returnValue = useMemo15(() => {
    return {
      emitter
    };
  }, [emitter]);
  return returnValue;
};

// src/ThumbnailUI.tsx
import { jsx as jsx15 } from "react/jsx-runtime";
var reactVersion2 = React14.version.split(".")[0];
if (reactVersion2 === "0") {
  throw new Error(`Version ${reactVersion2} of "react" is not supported by Remotion`);
}
var doesReactVersionSupportSuspense2 = parseInt(reactVersion2, 10) >= 18;
var ThumbnailUI = ({
  style,
  inputProps,
  errorFallback,
  renderLoading,
  className,
  overflowVisible,
  noSuspense,
  overrideInternalClassName
}, ref) => {
  const config = Internals16.useUnsafeVideoConfig();
  const video = Internals16.useVideo();
  const container = useRef13(null);
  const canvasSize = useElementSize(container, {
    triggerOnWindowResize: false,
    shouldApplyCssTransforms: false
  });
  const layout = useMemo16(() => {
    if (!config || !canvasSize) {
      return null;
    }
    return calculateCanvasTransformation({
      canvasSize,
      compositionHeight: config.height,
      compositionWidth: config.width,
      previewSize: "auto"
    });
  }, [canvasSize, config]);
  const scale = layout?.scale ?? 1;
  const thumbnail = useThumbnail();
  useBufferStateEmitter(thumbnail.emitter);
  useImperativeHandle3(ref, () => {
    const methods = {
      getContainerNode: () => container.current,
      getScale: () => scale
    };
    return Object.assign(thumbnail.emitter, methods);
  }, [scale, thumbnail.emitter]);
  const VideoComponent = video ? video.component : null;
  const outerStyle = useMemo16(() => {
    return calculateOuterStyle({
      config,
      style,
      canvasSize,
      overflowVisible,
      layout
    });
  }, [canvasSize, config, layout, overflowVisible, style]);
  const outer = useMemo16(() => {
    return calculateOuter({ config, layout, scale, overflowVisible });
  }, [config, layout, overflowVisible, scale]);
  const containerStyle = useMemo16(() => {
    return calculateContainerStyle({
      config,
      layout,
      scale,
      overflowVisible
    });
  }, [config, layout, overflowVisible, scale]);
  const onError = useCallback13((error) => {
    thumbnail.emitter.dispatchError(error);
  }, [thumbnail.emitter]);
  const loadingMarkup = useMemo16(() => {
    return renderLoading ? renderLoading({
      height: outerStyle.height,
      width: outerStyle.width,
      isBuffering: false
    }) : null;
  }, [outerStyle.height, outerStyle.width, renderLoading]);
  const currentScaleContext = useMemo16(() => {
    return {
      type: "scale",
      scale
    };
  }, [scale]);
  if (!config) {
    return null;
  }
  const content = /* @__PURE__ */ jsx15("div", {
    style: outer,
    children: /* @__PURE__ */ jsx15("div", {
      style: containerStyle,
      className: playerCssClassname(overrideInternalClassName),
      children: VideoComponent ? /* @__PURE__ */ jsx15(ErrorBoundary, {
        onError,
        errorFallback,
        children: /* @__PURE__ */ jsx15(Internals16.CurrentScaleContext.Provider, {
          value: currentScaleContext,
          children: /* @__PURE__ */ jsx15(VideoComponent, {
            ...video?.props ?? {},
            ...inputProps ?? {}
          })
        })
      }) : null
    })
  });
  if (noSuspense || IS_NODE && !doesReactVersionSupportSuspense2) {
    return /* @__PURE__ */ jsx15("div", {
      ref: container,
      style: outerStyle,
      className,
      children: content
    });
  }
  return /* @__PURE__ */ jsx15("div", {
    ref: container,
    style: outerStyle,
    className,
    children: /* @__PURE__ */ jsx15(Suspense2, {
      fallback: loadingMarkup,
      children: content
    })
  });
};
var ThumbnailUI_default = forwardRef3(ThumbnailUI);

// src/Thumbnail.tsx
import { jsx as jsx16 } from "react/jsx-runtime";
var ThumbnailFn = ({
  frameToDisplay,
  style,
  inputProps,
  compositionHeight,
  compositionWidth,
  durationInFrames,
  fps,
  className,
  errorFallback = () => "⚠️",
  renderLoading,
  overflowVisible = false,
  overrideInternalClassName,
  logLevel = "info",
  preferredEffectBackend = "auto",
  noSuspense,
  ...componentProps
}, ref) => {
  if (typeof window !== "undefined") {
    useLayoutEffect4(() => {
      window.remotion_isPlayer = true;
    }, []);
  }
  const rootRef = useRef14(null);
  const audioAndVideoTags = useRef14([]);
  const bufferingStore = useMemo17(() => Internals17.createRuntimeValueStore({ buffering: false }), []);
  const timelineState = useMemo17(() => {
    const value = {
      isPlaying: () => false,
      isInsideFreeze: false,
      frame: {
        [PLAYER_COMP_ID]: frameToDisplay
      },
      audioAndVideoTags
    };
    return value;
  }, [frameToDisplay]);
  const playbackRateContext = useMemo17(() => {
    return {
      playbackRate: 1,
      setPlaybackRate: () => {
        throw new Error("thumbnail");
      }
    };
  }, []);
  const frameRef = useRef14(timelineState.frame);
  frameRef.current = timelineState.frame;
  const setTimelineContext = useMemo17(() => {
    return {
      setFrameWithoutSeek: () => {
        return;
      },
      seek: null,
      setPlaying: () => {
        return;
      },
      setBuffering: (buffering) => {
        if (bufferingStore.store.getSnapshot().buffering !== buffering) {
          bufferingStore.setSnapshot({ buffering });
        }
      },
      subscribePlaying: () => () => {
        return;
      },
      subscribeBuffering: bufferingStore.store.subscribe,
      isPlaying: () => false,
      isBuffering: () => bufferingStore.store.getSnapshot().buffering,
      frameRef,
      audioAndVideoTags
    };
  }, [bufferingStore]);
  useImperativeHandle4(ref, () => rootRef.current, []);
  const Component = Internals17.useLazyComponent({
    compProps: componentProps,
    componentName: "Thumbnail",
    noSuspense: Boolean(noSuspense)
  });
  const [emitter] = useState13(() => new ThumbnailEmitter);
  const passedInputProps = useMemo17(() => {
    return inputProps ?? {};
  }, [inputProps]);
  return /* @__PURE__ */ jsx16(Internals17.IsPlayerContextProvider, {
    children: /* @__PURE__ */ jsx16(Internals17.SetTimelineContext.Provider, {
      value: setTimelineContext,
      children: /* @__PURE__ */ jsx16(SharedPlayerContexts, {
        timelineContext: timelineState,
        playbackRateContext,
        preservePitch: false,
        component: Component,
        compositionHeight,
        compositionWidth,
        durationInFrames,
        fps,
        numberOfSharedAudioTags: 0,
        initiallyMuted: true,
        logLevel,
        audioLatencyHint: "playback",
        preferredEffectBackend,
        sampleRate: 48000,
        inputProps: passedInputProps,
        audioEnabled: false,
        _experimentalKeepAudioContextAlive: false,
        children: /* @__PURE__ */ jsx16(ThumbnailEmitterContext.Provider, {
          value: emitter,
          children: /* @__PURE__ */ jsx16(ThumbnailUI_default, {
            ref: rootRef,
            className,
            errorFallback,
            inputProps: passedInputProps,
            renderLoading,
            style,
            overflowVisible,
            overrideInternalClassName,
            noSuspense: Boolean(noSuspense)
          })
        })
      })
    })
  });
};
var forward2 = forwardRef4;
var Thumbnail = forward2(ThumbnailFn);

// src/index.ts
var PlayerInternals = {
  PlayerEventEmitterContext,
  PlayerEmitter,
  usePlayerMethods,
  usePlayback,
  useElementSize,
  calculateCanvasTransformation,
  useHoverState,
  updateAllElementsSizes,
  PlayerEmitterProvider,
  BufferingIndicator,
  PlayerControls: Controls,
  TimelineSequenceObserverContext,
  CanvasOverlayContext,
  CanvasContentContext
};
export {
  Player,
  PlayerInternals,
  Thumbnail
};
